<template>
  <div>
    <form-wizard
      color="var(--accent3-color)"
      :title="null"
      :subtitle="null"
      shape="square"
      :finish-button-text='$t(`message.finish_btn`)'
      :back-button-text='$t(`message.btn_previous`)'
      :next-button-text='$t(`message.btn_next`)'
      class="mb-3"
      @on-complete="formSubmitted"
    >

    <template>
      <div>
        <b-alert
          :show="dismissCountDown2"
          dismissible
          fade
          variant="danger"
          @dismiss-count-down="countDownChanged2"
        >
          {{$t('message.maxtravellers')}}
        </b-alert>
      </div>
    </template>

      <!-- quote details tab -->
      <tab-content
        :title='$t(`message.quote_details`)'
        :before-change="validationForm"
        style="position:relative"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >

        <div id="savedQuotationsDrop" v-if="previousQuotations.length" style="text-align:right;">
          <b-dropdown id="dropdown-1" dropleft :text="$t(`message.previous_quotationsbtn`)" size="sm" class="dropdown-menu-end">
            <b-dropdown-item @click="newQuotation()">{{ $t(`message.new_quotationsbtn`) }}</b-dropdown-item>
            <b-dropdown-item v-for="p in previousQuotations.slice(0,5)" :key="p[0]" @click="sessionQuotation(p[0])">{{p[1]}}</b-dropdown-item>
          </b-dropdown>
        </div>

          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="h5_style">
                {{$t('message.rq')}} 
              </h5>
              <small class="small_style">
                {{$t('message.entrdts')}}
              </small>
              
            </b-col>

            <!-- quotation -->
            <b-col md="6" v-if="ls_role=='admin'">
              <b-form-group
                :label='$t(`message.onbehalfof`)'
                label-for="v-behalf-of"
              >
                <v-select
                  input-id="v-behalf-of"
                  v-model="selectedBehalfOf"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="behalfOf"
                  :selectable="option => ! option.value.includes('Choose...')"
                  :clearable="false"
                  label="text"
                  @input="synchBehalfOf"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="ls_role=='admin'">
              <b-form-group
                :label='$t(`message.agent`)'
                label-for="v-agent"
              >
                <v-select
                  input-id="v-agent"
                  v-model="selectedAgent"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="agentName"
                  :selectable="option => ! option.value.includes('To...')"
                  :clearable="false"
                  label="text"
                  @input="agentSelected"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label-for="v-country-from">
              <template #label>
                {{ $t('message.f_country') }}
                <span v-b-tooltip.hover.top='$t(`message.sompogrcy`)'>
                  <i class="fa-solid fa-circle-info fa-lg cursor-pointer text-primary"></i>
                </span>
              </template>
                <v-select
                  input-id="v-country-from"
                  v-model="selectedContryFrom"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="countrysFrom"
                  :selectable="option => ! option.value.includes('From...')"
                  :clearable="false"
                  label="text"
                  @input="select_country_from"
                />
                <!-- start select validation -->
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                >
                <input type="hidden" name="From Country" id="fromCountryfHidden" v-model="fromCountryfHidden" :state="errors.length > 0 ? false:null">
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <!-- end select validation -->
                <span ref="noticeSompo" class="small text-secondary d-none">Sompo International cover is not available for your departure country. Please select an alternative provider.</span>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="v-country-destinations"
              >
              <template #label>
                {{ $t('message.t_country') }}
                <span v-b-tooltip.hover.top='$t(`message.sompoadminselect`)'>
                  <i class="fa-solid fa-circle-info fa-lg cursor-pointer text-primary"></i>
                </span>
              </template>
                <v-select
                  input-id="v-country-destinations"
                  v-model="selectedContryTo"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="countrysTo"
                  :selectable="isSelectableCountry"
                  :clearable="false"
                  label="text"
                  @input="select_country_to"
                />
                <!-- start select validation -->
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                >
                <input type="hidden" name="To Destinations" id="toCountryfHidden" v-model="toCountryfHidden" :state="errors.length > 0 ? false:null">
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <!-- end select validation -->
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.via`)'
                label-for="v-via"
              >
                <v-select 
                  ref="viaSelect"
                  multiple
                  input-id="v-via"
                  v-model="selectedVia"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="countryVia"
                  :selectable="isSelectableViaCountry"
                  label="text"
                  @input="select_country_via"
                  :disabled="viastate"
                  :taggable="false"
                  @search:blur="onSearchBlur"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                  <template #label>
                    Upload Traveller Excel (optional)
                    <span v-b-tooltip.hover.top="'Please ensure your Excel file includes First Name, Last Name, and Date of Birth (required). Optionally, you can include Middle Name, Mobile, and Title (recommended). The Date of Birth column can use one of these formats: DD-MM-YYYY, DD/MM/YYYY, DD-MMM-YYYY, or DD-Month-YYYY. For the Title column, you can use M, Mr for males, and F, Mrs for females.'">
                      <i class="fa-solid fa-circle-info fa-lg cursor-pointer text-primary"></i>
                    </span>
                    <a
                      href="/files/sample-travellers.xlsx"
                      download="sample-travellers.xlsx"
                      class="ml-cst"
                      v-b-tooltip.hover.top="'Download sample Excel'"
                    >
                    <i class="fa-solid fa-file-arrow-down fa-lg cursor-pointer text-success"></i>
                    </a>
                  </template>
                <b-input-group>
                  <b-form-file
                    v-model="excelFile"
                    accept=".xlsx"
                    ref="excelInput"
                    class="excel-file"
                    @change="handleExcelUpload"
                  />
                  <b-input-group-append v-if="excelUploaded">
                    <b-button variant="danger" @click="clearExcel" size="sm">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.input_ages`)'
                label-for="input_ages"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Insured Persons"
                  rules="required"
                >
                  <b-form-input
                    id="input_ages"
                    v-model="input_ages"
                    :readonly="excelUploaded"
                    :state="errors.length > 0 ? false:null"
                    placeholder="23,53,58"
                    @blur="onAgesBlur"
                    @keypress="isNumber"
                    autocomplete="off"
                  />
                  <small v-if="errors[0]" class="text-danger">{{ errors[0] }}.</small>
                  <small v-if="duplicatecommas" class="text-danger">{{ duplicatecommas }}</small>
                  <small v-if="adult_supervisor" class="text-danger">{{ adult_supervisor }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.tr_number`)'
                label-for="travellers_number"
              >
                <validation-provider
                  #default="{ errors }"
                  name="travellers number"
              
                >
                  <b-form-input
                    id="travellers_number"
                    type="number"
                    readonly
                    v-model="travellers_number"
                    :state="errors.length > 0 ? false:null"
                    placeholder="0"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <b-form-group
                :label='$t(`message.booking_cost`)'
                label-for="booking_costs"
              >
                <validation-provider
                  #default="{ errors }"
                  name="booking costs"
                >
                  <b-form-input
                    id="booking_costs"
                    type="number"
                    v-model="booking_costs"
                    placeholder="0"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <b-col md="6">
              <b-form-group
                :label="date_range_label || date_range"
                label-for="daterange"
              >
              <v-date-picker :key="datePickerKey" v-model="range" is-range :min-date='minDate' @input="daterangePicker" :locale='$t(`message.locale`)' :masks="masks" :input-debounce="500" :update-on-input="true" mode="date" is-required>
                <template v-slot="{ inputValue, inputEvents }">
                  <div class="d-flex justify-center items-center">
                    <input
                      id="daterange"
                      :value="inputValue.start"
                      v-on="inputEvents.start"
                      class="form-control"
                    />
                    <svg
                      class="w-4 h-4 mx-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      width="20px"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                    <input
                      id="daterange_end"
                      :value="inputValue.end"
                      v-on="inputEvents.end"
                      class="form-control"
                    />
                  </div>
                </template>
              </v-date-picker>
              <small v-if="dateIsToday" class="text-danger">
                ⚠️ Please confirm your travel dates. These fields default to today’s date.
              </small>
              <small v-if="dateIsEmpty" class="text-danger">
                ⚠️ Please select both start and end dates.
              </small>
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <b-form-group
                :label='$t(`message.policyholder`)'
                label-for="policyholder"
              >
                <validation-provider
                  #default="{ errors }"
                  name="policyholder"
                >
                  <b-form-input
                    id="policyholder"
                    type="number"
                    v-model="policyholder"
                    placeholder="type policyholder"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group
                :label='$t(`message.select_clauses`)'
                label-for="v-select-clauses"
              >
                <v-select
                  taggable 
                  multiple
                  input-id="v-select-clauses"
                  v-model="selectedClauses"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="clausesArr"
                  :selectable="option => ! option.value.includes('Select...')"
                  label="text"
                  @input="showClauses"
                />
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="12">
              <b-form-group
                :label='$t(`message.clauses`)'
                label-for="v-show-clauses"
              >
                <textarea rows="7" style="width:100%;" name="showclaussess" id="showclaussess"></textarea>
              </b-form-group>
            </b-col> -->
          </b-row>

          <!-- quotation -->

    
        </validation-observer>
      </tab-content>

      <!-- products info tab -->
      <tab-content
        :title='$t(`message.products_info`)'
        :before-change="validationFormInfo"
      >
        <template>
          <div>
            <b-alert
              :show="dismissCountDown"
              dismissible
              fade
              variant="danger"
              @dismiss-count-down="countDownChanged"
            >
              {{alertMsg}}
            </b-alert>
          </div>
        </template>

        <b-row>
          <b-col
            cols="12"
            class="text-center"
            >
            <div class="d-flex align-items-center justify-content-center mb-2">
              <h2 class="tripPlanning mb-0">{{$t('message.tripPlanning')}}</h2>
              <!-- toggle table -->
              <b-button
                variant="link"
                class="p-0 ml-25"
                @click="toggleCoverage"
              >
                <span
                    :class="[
                      'transition-icon',
                      showCoverage ? 'rotate-up' : 'rotate-down'
                    ]"
                    style="display: inline-block;"
                  >
                    <span v-show="showCoverage">
                      <font-awesome-icon
                        icon="fa-sharp fa-circle-chevron-up"
                        size="lg"
                      />
                    </span>
                    <span v-show="!showCoverage">
                      <font-awesome-icon
                        icon="fa-sharp fa-circle-chevron-down"
                        size="lg"
                      />
                    </span>
                </span>
              </b-button>
            </div>
            <!-- table -->
              <b-col class="mx-auto" cols="12" sm="6">
                <b-collapse id="coverage-table" :visible="showCoverage">
                  <b-table :items="coverageRows" :fields="fields" bordered striped small responsive>
                    <template #cell(basic)="data">
                      <span>{{ data.item.basic }}</span>
                    </template>
                    <template #cell(extended)="data">
                      <span>{{ data.item.extended }}</span>
                    </template>
                    <template #cell(luxury)="data">
                      <span>{{ data.item.luxury }}</span>
                    </template>
                  </b-table>
                </b-collapse>
              </b-col>
              <!-- Before fetch pre select products category -->
              <div v-if="!this.showProducts" class="mb-2">
                <b-button-group>
                  <b-button
                    class="singletripbtn_f"
                    :class="{ active: selectedProductCategory === 'SingleTrip' }"
                    @click="selectedProductCategory = 'SingleTrip'"
                  >
                    Single Trip
                  </b-button>
                  <b-button
                    class="longstaytripbtn_f"
                    :class="{ active: selectedProductCategory === 'Longstay' }"
                    @click="selectedProductCategory = 'Longstay'"
                  >
                    Longstay
                  </b-button>
                  <b-button
                    class="annualtripbtn_f"
                    :class="{ active: selectedProductCategory === 'Annual' }"
                    @click="selectedProductCategory = 'Annual'"
                  >
                    Annual Multi-Trip
                    <font-awesome-icon icon="fa-solid fa-circle-info" class="ml-1" v-b-tooltip.hover.top='$t(`message.policy_refers`)' />
                  </b-button>
                </b-button-group>
              </div>
              <button class="btn btn-success" id="getQuote" :disabled="isGettingQuote" @click="getQuote($event)">{{ isGettingQuote ? $t('message.please_wait') : $t('message.get_quote') }}</button>
          </b-col>
          <b-col
            cols="12"
          >
          <div class="d-flex justify-content-end" v-if="showProducts">
            <font-awesome-icon @click="classicViewLayout" class="cursor-pointer mr8" icon="fa-solid fa-list" size="lg" v-b-tooltip.hover.top='"classic view"'/>
            <font-awesome-icon @click="ListViewLayout" class="cursor-pointer" icon="fa-solid fa-table" size="lg" v-b-tooltip.hover.top='"list view"'/>
          </div>
          </b-col>
          <!-- start choose trip type -->
          <b-col
          v-if="this.showProducts"
          cols="12"
          class="text-center mt-1"
          >
            <div>
              <b-button-group>
                <b-button
                  class="singletripbtn"
                  :class="{ active: activeButton === 'SingleTrip' }"
                  @click="activeButton = 'SingleTrip'; showSelectedTypeProducts($event, 'Longstay', 'Annual')"
                >
                  Single Trip
                </b-button>
                <b-button
                  class="longstaytripbtn"
                  :class="{ active: activeButton === 'Longstay' }"
                  @click="activeButton = 'Longstay'; showSelectedTypeProducts($event, 'SingleTrip', 'Annual')"
                >
                  Longstay
                </b-button>
                <b-button
                  class="annualtripbtn"
                  :class="{ active: activeButton === 'Annual' }"
                  @click="activeButton = 'Annual'; showSelectedTypeProducts($event, 'SingleTrip', 'Longstay')"
                >
                  Annual Multi-Trip
                  <font-awesome-icon icon="fa-solid fa-circle-info" class="ml-1" v-b-tooltip.hover.top='$t(`message.policy_refers`)' />
                </b-button>
              </b-button-group>
            </div>
          </b-col>
          <!-- end choose trip type -->
          <b-col
            cols="12"
            class="text-center mt-2"
            >
            <Transition name="slide-fade">
              <div class="row" id="products_panel" v-if="showProductsClassic && showProducts" @click="disableSliderScroll">
                <ClassicProductView @selectProductChange="selectProduct" v-for="(product, index) in ajax_products" :key="product.index" :product_price="product_price[index]" :product_currency="product_currency[index]" :product_currency_symbol="product_currency_symbol" :product_category="product_category[index]" :product_code="product_code[index]" :product_description="product_description[index]" :product_name="product_name[index]" :product_short_description="product_short_description[index]" :primary="primary[index]" :secondary="secondary[index]" :resCheckName="resCheckName" :destCheckName="destCheckName" :startDate="initialRequest['start_date']" :daysNum="initialRequest['days']" :agesArr="agesArr" @update-initial-request="updateInitialRequest"/>
              </div>
            </Transition>
            <Transition name="slide-fade">
              <div class="row" id="products_panel_list" v-if="showProductsList && showProducts" @click="enableSliderScroll">
                <!-- slider buttons -->
                <div class="slider-buttons-wrapper">
                  <button class="scroll-button left" @click="scrollSliderLeft">
                    <feather-icon icon="ChevronLeftIcon" size="45" class="arrow-icon" />
                  </button>
                  <button class="scroll-button right" @click="scrollSliderRight">
                    <feather-icon icon="ChevronRightIcon" size="45" class="arrow-icon" />
                  </button>
                </div>
                <ListProductView @selectProductChange="selectProduct" v-for="(product, index) in ajax_products" :key="product.index" :product_price="product_price[index]" :product_currency="product_currency[index]" :product_currency_symbol="product_currency_symbol" :product_category="product_category[index]" :product_code="product_code[index]" :product_description="product_description[index]" :product_name="product_name[index]" :product_short_description="product_short_description[index]" :primary="primary[index]" :secondary="secondary[index]" :resCheckName="resCheckName" :destCheckName="destCheckName" :startDate="initialRequest['start_date']" :daysNum="initialRequest['days']" :agesArr="agesArr" @update-initial-request="updateInitialRequest"/>
              </div>
            </Transition>
          </b-col>
          <b-col cols="12" class="text-center" v-if="offerBtnState">
            <b-button variant="secondary" v-b-modal.modal-offer :disabled="offersavebtn">{{ $t('message.saveofferbtn') }}</b-button>
            <!-- save offer modal -->
            <b-modal id="modal-offer" :title="$t(`message.saveofferbtn`)" centered @ok="handleOk">
              <div v-if="showofferwaring" class="alert alert-warning small mb-1" role="alert">
                {{ $t('message.save_optionsaddons') }}
              </div>
              <b-form ref="offerForm" @submit.stop.prevent="handleOfferSubmit">
                <b-form-input v-model="offerName" placeholder="Plese enter a name for this offer" required minlength="6"></b-form-input>
                <span class="text-danger">{{ errorSOffer }}</span>
              </b-form>
            </b-modal>
            <!-- message offer modal -->
            <b-modal v-model="offermessagemodalshow" id="modal-offermessage" title="Saved Offer" centered>
              <p class="text-success">Offer has been saved</p>
            </b-modal>
          </b-col>
          <b-col
            cols="12"
            class="text-center"
          >
            <template>
              <div>
                <b-alert
                  class="mt-1"
                  :show="dismissCountDown1"
                  dismissible
                  fade
                  variant="danger"
                  @dismiss-count-down="countDownChanged1"
                >
                  {{$t('message.no_products')}}
                </b-alert>
              </div>
            </template>
          </b-col>
        </b-row>
      </tab-content>

      <!-- travellers info tab -->
      <tab-content
        :title='$t(`message.travellers`)'
        :before-change="validationFormAddress"
      >
        <validation-observer
          ref="addressRules"
          tag="form"
          id="travellers_form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="h5_style">
                {{$t(`message.travellers`)}}
              </h5>
              <small class="small_style">{{$t(`message.entr_tr_dts`)}}</small>
            </b-col>
          </b-row>
          <b-row v-for="(tr_item,i) in numberoftravellers" :key="tr_item.id" class="mb-3">
            <b-col cols="12">
              <h4 class="mb-1 travellerstitle" v-html="compinedHTML($t(`message.traveller`), i)"></h4>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.title`)'
                :label-for="'traveller_title' + (i + 1)"
              >
              <v-select
                :input-id="'traveller_title'+(i+1)"
                :name="'traveller_title'+(i+1)"
                v-model="tr_item.title"
                :options="traveller_select"
                label="text"
                :reduce="option => option.value"
                :clearable="false"
                @input="select_title_to($event, i)"
              />
              <input type="hidden" :id="'traveller_title_hidden'+(i+1)" :value="tr_item.title">
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.first_name`)'
                :label-for="'firstName'+(i+1)"
              >
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                  :rules="{
                    required: true,
                    min: 3,
                    regex: /^[^0-9]+$/
                  }"
                  :vid="tr_item.firstname"
                >
                  <b-form-input
                    class="travellersValidate"
                    :id="'firstName'+(i+1)"
                    :name="'firstName'+(i+1)"
                    v-model="tr_item.firstname"
                    :state="errors.length > 0 ? false:null"
                    placeholder="First Name"
                    autocomplete="off"
                    @change="saveFN($event, i)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.last_name`)'
                :label-for="'lastName'+(i+1)"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Last Name"
                  :rules="{
                    required: true,
                    min: 3,
                    regex: /^[^0-9]+$/
                  }"
                >
                  <b-form-input
                    class="travellersValidate"
                    :id="'lastName'+(i+1)"
                    :name="'lastName'+(i+1)"
                    v-model="tr_item.lastname"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Last Name"
                    autocomplete="off"
                    @change="saveLN($event, i)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="
                dateBirth_i=='en' ? dateBirthLabel[i].en 
                : dateBirth_i=='fr' ? dateBirthLabel[i].fr 
                : dateBirth_i=='de'? dateBirthLabel[i].de 
                : dateBirth_i=='es'? dateBirthLabel[i].es 
                : dateBirth_i=='pl'? dateBirthLabel[i].pl 
                : dateBirth_i=='ro'? dateBirthLabel[i].ro 
                : dateBirth_i=='it'? dateBirthLabel[i].it 
                : dateBirthLabel[i].gr"
                :label-for="'dateofbirth'+(i+1)"
                >
                <validation-provider
                  #default="{ errors }"
                  name="Date of birth"
                  rules="required"
                >
                  <v-date-picker v-model="tr_item.date" mode="date" :masks="masks" @input="() => removeDobHighlight(i)">
                    <template v-slot="{ inputValue, inputEvents }">
                      <input
                      :id="'dateofbirth'+(i+1)"
                      :name="'dateofbirth'+(i+1)"
                      :class="['form-control form_control_dateofbirth', dobHighlightFlags[i] ? 'highlight-dob' : '']"
                      :value="inputValue"
                      v-on="inputEvents"
                      />
                    </template>
                  </v-date-picker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <span class="small text-warning">⚠️ Auto-filled based on age. Please confirm your date of birth.</span>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.mobile`)'
                :label-for="'mobile'+(i+1)"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Mobile"
                  :rules="{
                    min: 10,
                    regex: /^[0-9]+$/
                  }"
                >
                  <b-form-input
                    type="number"
                    :id="'mobile'+(i+1)"
                    :name="'mobile'+(i+1)"
                    v-model="tr_item.mobile"
                    :state="errors.length > 0 ? false:null"
                    placeholder="8586883484"
                    autocomplete="off"
                    @change="saveMB($event, i)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col
              cols="12"
              class="mb-0"
            >
              <h5 class="h5_style mb-1">
                {{$t(`message.pdts`)}}
              </h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.ce`)'
                label-for="contact_email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Contact Email"
                  rules="required|email"
                >
                  <b-form-input
                    type="email"
                    id="contact_email"
                    v-model="contact_email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="valid@email.com - An e-mail containing the insurance Policy will be delivered on this address."
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.cust_street`)'
                label-for="customer_street"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Customer's Street"
                  :rules="{
                    required: true,
                    min: 3,
                    regex: /^[^0-9]+$/
                  }"
                >
                  <b-form-input
                    id="customer_street"
                    v-model="customer_street"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Holden Street"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.street_number`)'
                label-for="street_number"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Street Number"
                  :rules="{
                    required: true,
                    regex: /^[0-9]+$/
                  }"
                >
                  <b-form-input
                    id="street_number"
                    v-model="street_number"
                    :state="errors.length > 0 ? false:null"
                    placeholder="50"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.area`)'
                label-for="customer_area"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Area"
                  :rules="{
                    required: true,
                    min: 3,
                    regex: /^[^0-9]+$/
                  }"
                >
                  <b-form-input
                    id="customer_area"
                    v-model="customer_area"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Chinatown"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.city`)'
                label-for="customer_city"
              >
                <validation-provider
                  #default="{ errors }"
                  name="City"
                  :rules="{
                    required: true,
                    min: 3,
                    regex: /^[^0-9]+$/
                  }"
                >
                  <b-form-input
                    id="customer_city"
                    v-model="customer_city"
                    :state="errors.length > 0 ? false:null"
                    placeholder="London"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.ctin`)'
                label-for="tax_identification_number"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Customer's Tax Identification Number"
                  rules="required|min:3"
                >
                  <b-form-input
                    id="tax_identification_number"
                    v-model="tax_identification_number"
                    :state="errors.length > 0 ? false:null"
                    placeholder="9999999999"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.c_tel`)'
                label-for="customer_telephone"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Customer's Telephone"
                  :rules="{
                    required: true,
                    min: 10,
                    regex: /^[0-9]+$/
                  }"
                >
                  <b-form-input
                    type="number"
                    id="customer_telephone"
                    v-model="customer_telephone"
                    :state="errors.length > 0 ? false:null"
                    placeholder="8586883484"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.czip`)'
                label-for="customer_zip_code"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Customer's Zip Code"
                  rules="required|min:4"
                >
                  <b-form-input
                    id="customer_zip_code"
                    v-model="customer_zip_code"
                    :state="errors.length > 0 ? false:null"
                    placeholder="92109"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label='$t(`message.c_country`)'
                label-for="v-country-policyholder"
              >
                <v-select
                  input-id="v-country-policyholder"
                  v-model="selectedContryPolicyHolder"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="countrysFrom"
                  :selectable="option => ! option.value.includes('From...')"
                  label="text"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="check_product=='product-single-919'">
              <b-form-group
                :label='$t(`message.school`)'
                label-for="customer_school"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Customer's School"
                  rules="required"
                >
                  <b-form-input
                    id="customer_school"
                    v-model="customer_school"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Alfreton School, Greem Street, London, 71601"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="justify-content-center mt-1">
            <div class="col-12">
              <b-button class="d-block mx-auto" v-b-toggle.collapse-1 variant="secondary">{{$t(`message.additional_info`)}} 
                <span v-b-tooltip.hover.top='$t(`message.optional_additional_info`)'>
                  <i class="fa-solid fa-circle-info fa-lg cursor-pointer text-white"></i>
                </span>
              </b-button>
              <b-collapse :visible="additional_info_visible" id="collapse-1" class="mt-2">
                  <b-row>
                    <b-col md="6">
                      <b-form-group
                        :label='$t(`message.contr`)'
                        label-for="contracted_party_type"
                      >
                        <v-select
                          input-id="contracted_party_type"
                          v-model="contractedPartyTypeSelected"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="contractedPartyType"
                          :selectable="option => ! option.value.includes('From...')"
                          :clearable="false"
                          label="text"
                          @input="setContractedPartyType"
                        />
                      </b-form-group>
                    </b-col>
                    <!--  -->
                    <b-col md="6">
                      <b-form-group
                        :label='$t(`message.company_name`)'
                        label-for="company_name"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Company Name"
                          :rules="`${this.setcompanyName ? 'required' : ''}`"
                        >
                          <b-form-input
                            id="company_name"
                            v-model="company_name"
                            :state="errors.length > 0 ? false:null"
                            :disabled="companyNameDisabled"
                            placeholder="company name"
                            autocomplete="off"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        :label='$t(`message.doc_type`)'
                        label-for="document_type"
                      >
                        <v-select
                          input-id="document_type"
                          v-model="documentTypeSelected"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="documentType"
                          :selectable="option => ! option.value.includes('From...')"
                          :clearable="false"
                          label="text"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        :label='$t(`message.doc_number`)'
                        label-for="document_number"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Document Number"
                          :rules="`${this.product_is_mondial ? '' : ''}`"
                        >
                          <b-form-input
                            id="document_number"
                            v-model="document_number"
                            :state="errors.length > 0 ? false:null"
                            placeholder="AA09984"
                            autocomplete="off"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        :label='$t(`message.doc_auth`)'
                        label-for="document_authority"
                      >
                        <v-select
                          input-id="document_authority"
                          v-model="documentAuthoritySelected"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="documentAuthority"
                          :selectable="option => ! option.value.includes('From...')"
                          :clearable="false"
                          label="text"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        :label='$t(`message.doc_auth_cerf`)'
                        label-for="document_authority_certification"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Document Authority Certification"
                          :rules="`${this.product_is_mondial ? '' : ''}`"
                        >
                          <b-form-input
                            id="document_authority_certification"
                            v-model="document_authority_certification"
                            :state="errors.length > 0 ? false:null"
                            placeholder="tax authority or police department or authority issuing the passport"
                            autocomplete="off"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        :label='$t(`message.trip_text`)'
                        label-for="trip_info_text"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Trip Information Text"
                          :rules="`${this.product_is_mondial ? '' : ''}`"
                        >
                          <b-form-input
                            id="trip_info_text"
                            v-model="trip_info_text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="one way ticket"
                            autocomplete="off"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        :label='$t(`message.arr_city`)'
                        label-for="arrival_city"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Arrival City"
                          :rules="`${this.product_is_mondial ? '' : ''}`"
                        >
                          <b-form-input
                            id="arrival_city"
                            v-model="arrival_city"
                            :state="errors.length > 0 ? false:null"
                            placeholder="London"
                            autocomplete="off"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        :label='$t(`message.travel_price`)'
                        label-for="travel_price"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Travel Price"
                          :rules="`${this.product_is_mondial ? '' : ''}`"
                        >
                          <b-form-input
                            type="number"
                            id="travel_price"
                            v-model="travel_price"
                            :state="errors.length > 0 ? false:null"
                            placeholder="50"
                            autocomplete="off"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
              </b-collapse>
            </div>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- preview info tab -->
      <tab-content
        :title='$t(`message.preview`)'
        :before-change="validationFormSocial"
      >
        <validation-observer
          ref="socialRules"
          tag="form"
        >
        <b-row>
          <b-col
            cols="12"
            class="mb-0"
          >
          <h1 class="mb-2 previewdts">
            {{$t(`message.preview_dts`)}}
          </h1>
          </b-col>
        </b-row>
          <b-row id="reviewPanel">
              <form class="col-12">
                <fieldset>
                  <legend>{{$t(`message.about_y_trip`)}}</legend>
                  <div class="form-group row align-items-center">
                    <label class="col-md-7 col-form-label">{{$t(`message.type_of_policy`)}}</label>
                    <div class="col-md-3 pad_preview">
                      <input type="text" class="form-control" :value="this.initialRequest['product_category'] || ' -'" disabled>
                    </div>
                  </div>          
                  <div class="form-group row align-items-center">
                    <label class="col-md-7 col-form-label">{{$t(`message.tr_ins_policy`)}}</label>
                    <div class="col-md-3 pad_preview">
                      <input type="text" id="previewPolicy" class="form-control" :value="initialRequest['product_name'] || ' -'" disabled>
                    </div>
                  </div>          
                  <div class="form-group row align-items-center">
                    <label class="col-md-7 col-form-label">{{$t(`message.what_c_r`)}}</label>
                    <div class="col-md-3 pad_preview">
                      <input type="text" id="previewResidence" class="form-control" :value="initialRequest['res_name'] || ' -'" disabled>
                    </div>
                  </div>          
                  <div class="form-group row align-items-center">
                    <label class="col-md-7 col-form-label">{{$t(`message.where_c_r`)}} </label>
                    <div class="col-md-3 pad_preview previewquestions">
                      <input type="text" id="previewDestination" class="form-control" :value="initialRequest['des_name'] || ' -'" disabled>
                    </div>
                    <div class="col-md-1">
                      <font-awesome-icon id="popover-target-desktop" class="cursor-pointer" icon="fa-solid fa-question"/>
                      <b-popover target="popover-target-desktop" triggers="hover" placement="top">
                        <template #title>{{$t(`message.classed_europe`)}}</template>
                          {{$t(`message.europe_countries`)}}
                      </b-popover>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-md-7 col-form-label">{{$t(`message.inter_countries`)}}</label>
                    <div class="col-md-3 pad_preview">
                      <input type="text" id="previewVia" class="form-control" :value="initialRequest['via_countries'] || ' -'" disabled>
                    </div>
                  </div> 
                  <div class="form-group row align-items-center">
                    <label class="col-md-7 col-form-label">{{$t(`message.tr_number_cap`)}}</label>
                    <div class="col-md-3 pad_preview">
                      <input type="text" id="previewTravellerNumber" class="form-control" :value="initialRequest['travellersNumber'] || ' -'" disabled>
                    </div>
                  </div>           
                  <div class="form-group row align-items-center">
                    <label class="col-md-7 col-form-label">{{$t(`message.start_date_policy`)}}</label>
                    <div class="col-md-3 pad_preview">
                      <input type="text" id="previewStartDate" class="form-control" :value="initialRequest['start_date'] || ' -'" disabled>
                    </div>
                  </div>          
                  <div class="form-group row align-items-center">
                    <label class="col-md-7 col-form-label">{{$t(`message.end_date_policy`)}}</label>
                    <div class="col-md-3 pad_preview" v-if="this.initialRequest.product_category !== 'Annual'">
                      <input type="text" id="previewEndDate" class="form-control" :value="initialRequest['end_date'] || ' -'" disabled>
                    </div>
                    <div class="col-md-3 pad_preview" v-else>
                      <input type="text" id="previewEndDate" class="form-control" :value="initialRequest['annual_date'] || ' -'" disabled>
                    </div>
                  </div>          
                  <div class="form-group row align-items-center">
                    <label class="col-md-7 col-form-label">{{$t(`message.number_of_days`)}}</label>
                    <div class="col-md-3 pad_preview">
                      <input type="text" id="previewTripDates" class="form-control" :value="initialRequest['days'] || ' -'" disabled>
                    </div>
                  </div> 
                </fieldset>
              </form>       
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- buy policy tab  -->
      <tab-content
        :title='$t(`message.buy_policy`)'
      >
      <b-row>
        <b-col
          cols="12"
        >
          <b-alert variant="warning" show class="mb-2">
            <strong>{{$t(`message.preexisting`)}}</strong>
          </b-alert>
        </b-col>

        <!-- introduction -->
        <b-col
          cols="12"
          class="mb-1"
        >
          <div>
            <b-jumbotron class="sm_jumbotron" :header="$t(`message.introduction`)" header-level="5">
              <p class="lead">{{$t(`message.ins_dts_1`)}}</p>
              <p class="lead">{{$t(`message.ins_dts_2`)}}</p>
            </b-jumbotron>
          </div>
        </b-col>
        <!-- review your documents -->
        <b-col
          cols="12"
          class="mb-1"
        >
          <div>
            <b-jumbotron class="sm_jumbotron" :header="$t(`message.reviewyourdocs`)" header-level="5">
              <b-list-group class="d-inline-flex gap-2">
                <b-list-group-item class="w-auto">
                  Policy Wording (PDF) <a v-if="pwoLinkValue" :href="pwoLinkValue" target="_blank"><font-awesome-icon :icon="['fas', 'link']" size="lg" /></a>
                </b-list-group-item>
                <!-- longstay-302 -->
                <b-list-group-item class="w-auto" v-if="initialRequest && initialRequest.product === 'product-longstay-302'">
                  Addition to the Policy Wording (PDF) <a v-if="pwoLinkValueAddition" :href="pwoLinkValueAddition" target="_blank"><font-awesome-icon :icon="['fas', 'link']" size="lg" /></a>
                </b-list-group-item>
                <b-list-group-item class="w-auto">
                  Insurance Policy Information Document (IPID) <a v-if="ipidLinkValue" :href="ipidLinkValue" target="_blank"><font-awesome-icon :icon="['fas', 'link']" size="lg" /></a>
                </b-list-group-item>
                <b-list-group-item class="w-auto">
                  Schedule of Coverage (TOB) <a v-if="tobLinkValue" :href="tobLinkValue" target="_blank"><font-awesome-icon :icon="['fas', 'link']" size="lg" /></a>
                </b-list-group-item>
              </b-list-group>
            </b-jumbotron>
          </div>
        </b-col>
        <b-col
          cols="12"
        >
          <div>
            <b-jumbotron class="sm_jumbotron" :header="$t(`message.agreements`)" header-level="5">
              <h4>{{$t(`message.imp_cond`)}}</h4>
              <p class="lead">{{$t(`message.introduction`)}}<br>{{$t(`message.ins_dts_3`)}}<br>{{$t(`message.ins_dts_4`)}}<br>{{$t(`message.ins_dts_5`)}}</p>
              <p class="lead">{{$t(`message.ins_dts_6`)}}</p>
              <p class="lead" v-if="initialRequest && initialRequest.product === 'product-longstay-302'">{{$t(`message.ins_dts_6_1`)}}</p>
              <template>
                <div>
                  <b-form-radio-group
                    v-model="selected_coverages"
                    :options="coverages_options"
                    class="mb-2"
                    value-field="item"
                    text-field="name"
                    disabled-field="notEnabled"
                  ></b-form-radio-group>
                </div>
              </template>
              <h4>{{$t(`message.personal_data`)}}</h4>
              <p class="lead">{{$t(`message.ins_dts_7`)}}</p>
              <h4>{{$t(`message.health_cond`)}}</h4>
              <p class="lead">{{$t(`message.ins_dts_8`)}}</p>
              <h4>{{$t(`message.pre_exs`)}}</h4>
              <p class="lead">{{$t(`message.ins_dts_9`)}}</p>
              <!-- medical declaration modal -->
              <b-button size="md" variant="outline-secondary" @click="modal_medeclaration = true">{{$t(`message.declaration`)}}</b-button>
              <MedicalModal
                v-model="modal_medeclaration"
                :medical-form="medical_form"
                :errors="medical_form_errors"
                :pdf-link="pdfLink"
                :traveller-select="traveller_select"
                :policy-type-options="policy_type_options"
                :policy-cover-options="policy_cover_options"
                :date-today="date_today"
                @medical-submit="handleMedicalFormSubmit"
              />
              <b-modal
                v-model="modal_notify"
                hide-footer
                title="Submission Successful"
                centered
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
                :hide-header-close="true"
              >
                <p class="my-2">
                  Your application has been successfully submitted.<br>
                  We will review your application and notify you shortly.
                </p>
                <div class="text-right">
                  <b-button variant="primary" @click="handleNotifyOk">
                    OK
                  </b-button>
                </div>
              </b-modal>
              <h4 class="mt-2">{{$t(`message.pol_rel`)}}</h4>
              <ol type="a" class="lead">
                <li>{{$t(`message.pol_li_1`)}}</li>
                <li>{{$t(`message.pol_li_2`)}}</li>
                <li>{{$t(`message.pol_li_3`)}}</li>
                <li>{{$t(`message.pol_li_4`)}}</li>
                <li>{{$t(`message.pol_li_5`)}}</li>
                <li>{{$t(`message.pol_li_6`)}}</li>
              </ol>
              <h4 class="mt-2">{{$t(`message.medical_thr_country`)}}</h4>
              <p class="lead">{{$t(`message.awr_med`)}}</p>
              <template>
                <div>
                  <b-form-radio-group
                    v-model="selected_treatment"
                    :options="treatment_options"
                    class="mb-2"
                    value-field="item"
                    text-field="name"
                    disabled-field="notEnabled"
                  ></b-form-radio-group>
                </div>
              </template>
              <p class="lead">{{$t(`message.agree_med`)}}</p>
              <template>
                <div>
                  <b-form-radio-group
                    v-model="selected_medical"
                    :options="medical_options"
                    class="mb-2"
                    value-field="item"
                    text-field="name"
                    disabled-field="notEnabled"
                  ></b-form-radio-group>
                </div>
              </template>
              <!-- Consent to receive the policy -->
              <div class="d-flex">
                <b-form-checkbox
                  v-model="consent_pd"
                  value="A"
                  unchecked-value="B"
                >
                </b-form-checkbox>
                <p class="lead">{{$t(`message.consent_pd_txt`)}}</p>
              </div>
              <!-- Confirm policy wording and the IPID -->
              <div class="d-flex">
                <b-form-checkbox
                  v-model="confirm_plword"
                  value="A"
                  unchecked-value="B"
                >
                </b-form-checkbox>
                <p class="lead">{{$t(`message.confirm_plword`)}}</p>
              </div>
              <!-- agree privacy policy -->
              <div class="d-flex">
                <b-form-checkbox
                  v-model="confirm_prv_plcy"
                  value="A"
                  unchecked-value="B"
                >
                </b-form-checkbox>
                <p class="lead">{{$t(`message.confirm_prv_plcy`)}} 
                  <router-link :to="'/privacy'" target="_blank" style="font-weight:600;">
                    {{$t(`message.confirm_prv_plcy_link`)}}
                  </router-link>
                </p>
              </div>
              <p class="font-600">{{$t(`message.understand_med`)}}</p>
              <span v-if="!isAllYes" class="text-danger mt-2">{{$t(`message.not_be_eligible`)}}</span>
            </b-jumbotron>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="text-center"
        >
        <template>
          <div>
            <b-form-checkbox
              :disabled="checkpolicystatus"
              v-model="switched_checked_accept"
              name="check-button"
              switch
            >
              <b>{{ $t('message.accept_cond') }}</b>
            </b-form-checkbox>
          </div>
        </template>
        </b-col>
        <b-col
        cols="12"
        class="text-center mt-2"
        >
          <b-button v-if="ls_scope.includes('app.travel-insurance.payment')" variant="success" size="lg" :disabled="buypolicystatus" @click='buyProduct($event)'>{{buy_policy_text}}</b-button>
          <b-button v-else variant="danger" size="lg" disabled>{{$t(`message.demo_policy`)}}</b-button>
          <b-button class="ml-1" size="lg" v-if='paymentdts' variant="secondary" v-b-modal.paymentdetailsmodal>{{$t(`message.payment_dts`)}}</b-button>

          <!--start payment modals -->
          <b-modal id="paymentdetailsmodal" title="Policy Status" v-model="paymentmodalshow" ok-only>
            <div class="alert alert-success alert-dismissible fade show" role="alert">
              <font-awesome-icon icon="fa-solid fa-check"/> <strong v-if="display_reserve_msg">{{$t(`message.thx_messgae`)}}</strong> <strong v-if="display_purchase_msg">{{$t(`message.thx_messgae_purch`)}}</strong>
              <div v-if="display_payment_ammount">
                <a :href="hrefpaymentlink" target="_blank" class="btn btn-sm btn-outline-success d-block font-weight-bolder">{{$t(`message.payment_proceed`)}}</a>
                <div class="mt-1">
                  <span>{{$t(`message.pay_using`)}}</span>
                  <img :src="vivacardsimg" alt="payment methods" class="img-fluid">
                </div>
              </div>
            </div>
            <ul id="listgroupdets" class="list-group">
              <li class="list-group-item" id="displayproduct"><span class='font-bold'>{{$t(`message.product`)}}</span> {{ displayproduct }}</li>
              <li class="list-group-item" id="displayprice"><span class='font-bold'>{{$t(`message.policy_price`)}}</span> {{ displayprice }}</li>
              <li class="list-group-item" id="payableto"><span class='font-bold'>{{$t(`message.payable_to`)}}</span> {{ payableto }}</li>
              <li class="list-group-item" id="payableamount" v-if="display_payment_ammount"><span class='font-bold'>{{$t(`message.payable_amount`)}}</span> {{ payableamount }}</li>
              <!-- <li id="displaypaymentli" v-if="display_payment_ammount" class="list-group-item"><a class='font-bold paymentlinka' id="displaypayment" :href="hrefpaymentlink" target="_blank">{{$t(`message.click_here_pay`)}}</a><button @click='copylink' class="btn btn-sm btn-outline-secondary ml-3">Copy link</button></li> -->
            </ul>
          </b-modal>

          <b-modal id="errorbuyProductModal" title="Policy Status" v-model="paymentmodalerrorshow" centered ok-only>
            <p class="lead" style="font-weight: 400;">{{ errorbuyProductModalMsg }}</p>
          </b-modal>
          <!-- end payment modals -->
        </b-col>
      </b-row>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import moment from 'moment'
import { countrysFrom, countrysTo, countryVia, product_documents, euCountries } from '@/products';
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { performLogoutWithoutRedirect } from '@/auth/logout'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  VBTooltip,
  BAlert,
  BCollapse,
  BButton,
  BButtonGroup,
  VBToggle,
  BCard,
  BSidebar,
  BJumbotron,
  BFormRadioGroup,
  BFormCheckbox,
  BLink,
  BPopover,
  VBModal,
  BDropdown,
  BDropdownItem, 
  BDropdownDivider,
  BForm,
  BTable,
  BListGroup,
  BListGroupItem,
  BFormFile,
  BInputGroup,
  BInputGroupAppend
} from 'bootstrap-vue'
import { required, email, min } from '@validations'
import { codeIcon } from './code'
import ClassicProductView from './ClassicProductView'
import ListProductView from './ListProductView'
import MedicalModal from './MedicalModal'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    ToastificationContent,
    VBTooltip,
    ClassicProductView,
    ListProductView,
    MedicalModal,
    BAlert,
    BCollapse,
    BButton,
    BButtonGroup,
    VBToggle,
    BCard,
    BSidebar,
    BJumbotron,
    BFormRadioGroup,
    BFormCheckbox,
    BLink,
    BPopover,
    VBModal,
    BDropdown,
    BDropdownItem, 
    BDropdownDivider,
    BForm,
    BTable,
    BListGroup,
    BListGroupItem,
    BFormFile,
    BInputGroup,
    BInputGroupAppend
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
    'b-dropdown': BDropdown
  },
  data() {
    return {
      medical_form_errors: {},
      date_today: new Date().toISOString().split('T')[0],
      medical_form: {
        travellers: [
          {
            title: null,
            firstname: '',
            lastname: '',
            dob: null,
            age: null,
          }
        ],
        country:'',
        address:'',
        telephone:'',
        mobile:'',
        email:'',
        start_date:null,
        end_date:null,
        policy_type:null,
        destination:null,
        policy_cover:null,
        cost:null,
        conditions:'',
        hazardous_activities:[],
        special_requests:'',
        declarations: {
          introduction: false,
          coverage: false,
        },
        questions: {
          q1: false,
          q2: false,
          q3: false,
          q4: false,
          q5: false,
          q6: false,
        },
        signature: '',
        signature_date: new Date().toISOString().split('T')[0],
      },
      policy_type_options:[
        { value: 'Single Trip', text: 'Single Trip' },
        { value: 'Annual', text: 'Annual' },
        { value: 'Long Stay', text: 'Long Stay' }
      ],
      policy_cover_options:[
        { value: 'Basic', text: 'Basic' },
        { value: 'Extended', text: 'Extended' },
        { value: 'Luxury', text: 'Luxury' },
        { value: 'Study', text: 'Study' },
        { value: 'Travel Agent Leisure', text: 'Travel Agent Leisure' }
      ],
      modal_medeclaration:false,
      modal_notify:false,
      date_range_label: '',
      blockedCountryIds: ['520','1059','285','595','805','985','95','580','550','760','1042'],
      offersavebtn:false,
      showofferwaring: false,
      isGettingQuote: false,
      travellerData:[],
      display_reserve_msg:true,
      display_purchase_msg:false,
      selectedProductCategory: "SingleTrip", // default
      activeButton: "SingleTrip",
      pdfLink: '/files/SFT_-_Application_Form.pdf',
      showCoverage: true,
      dobHighlightFlags: [],
      pwoLinkValue: null,
      ipidLinkValue: null,
      tobLinkValue: null,
      pwoLinkValueAddition: null,
      fields: [
        { key: 'type', label: 'Coverage Type' },
        { key: 'basic', label: 'Basic' },
        { key: 'extended', label: 'Extended' },
        { key: 'luxury', label: 'Luxury' }
      ],
      coverageRows: [
        { type: 'Medical', basic: '✓', extended: '✓✓', luxury: '✓✓✓' },
        { type: 'Baggage', basic: '✓', extended: '✓✓', luxury: '✓✓✓' },
        { type: 'Cancellation', basic: '✓', extended: '✓', luxury: '✓✓' },
        { type: 'Winter Add-on', basic: '✕', extended: '✓', luxury: '✓✓' },
        { type: 'Business Add-on', basic: '✕', extended: '✓', luxury: '✓✓' }
      ],
      dateIsToday:false,
      dateIsEmpty:false,
      vivacardsimg: require('@/assets/images/quotation/cards_viva.svg'),
      alertMsg: '',
      errorSOffer: '',
      sv_offer: {},
      offerName: '',
      offerName:'',
      viastate:true,
      datePickerKey: 0,
      duplicatecommas: null,
      adult_supervisor: null,
      loadFormDts:[{},{},{},{}],
      dateBirth_i:'en',
      hrefpaymentlink:'',
      display_payment_ammount: true,
      displayproduct:'',
      displayprice:'',
      payablefrom:'',
      payableto:'',
      payableamount:'',
      errorbuyProductModalMsg:'',
      paymentmodalshow:false,
      offermessagemodalshow:false,
      paymentmodalerrorshow:false,
      paymentdts:false,
      all_products_arr:[],
      index:null,
      dateBirthLabel:[],
      prevval:[],
      todayval:[],
      birthDatesArr:[],
      buypolicystatus:true,
      checkpolicystatus:false,
      switched_checked_accept:false,
      selected_coverages:'B',
      coverages_options:[
        { item: 'A', name: 'Yes', value: 'Yes' },
        { item: 'B', name: 'No', value: 'No' },
      ],
      selected_treatment:'B',
      treatment_options:[
        { item: 'A', name: 'Yes', value: 'Yes' },
        { item: 'B', name: 'No', value: 'No' },
      ],
      selected_medical:'B',
      medical_options:[
        { item: 'A', name: 'Yes', value: 'Yes' },
        { item: 'B', name: 'No', value: 'No' },
      ],
      consent_pd:'B',
      confirm_plword:'B',
      confirm_prv_plcy:'B',
      company_name:'',
      setcompanyName:'',
      additional_info_visible:false,
      product_is_mondial:false,
      product_is_kemter:false,
      product_is_battleface:false,
      product_is_sompo:false,
      productIsSelected:false,
      dismissSecs:5,
      dismissSecs1:7,
      dismissSecs2:5,
      dismissCountDown:0,
      dismissCountDown1:0,
      dismissCountDown2:0,
      showSaveOfferButton: true,
      showDismissibleAlert:false,
      selectedProduct:false,
      showProducts:false,
      showProductsClassic:true,
      showProductsList:false,
      ajax_products:[],
      masks:{
        input: "DD-MM-YYYY"
      },
      minDate: new Date(),
      range:{
        start: new Date(),
        end: new Date(),
      },
      excelFile: null,
      excelUploaded: false,
      // dynamic values based on number of travellers 
      numberoftravellers:[],
      traveller_title:{
        value: 'Mr.', 
        text: 'Mr.'
      },
      contact_email:'',
      customer_street:'',
      street_number:'',
      customer_area:'',
      customer_city:'',
      tax_identification_number:'',
      customer_telephone:'',
      selectedBehalfOf: {
        text:'Vasilis Pallidis Insurance Brokers',
        value:'248',
      },
      fromCountryfHidden:'',
      toCountryfHidden:'',
      selectedAgent: {
        text:'aderisiotis@safetravel.today',
        value:null
      },
      selectedContryFrom:'',
      selectedContryPolicyHolder:'',
      selectedContryTo:'',
      selectedVia:[],
      selectedContry:'',
      booking_costs:'',
      policyholder:'',
      selectedClauses:'',
      selectedClauseOperation:'',
      selectedAdditionalAmount:'',
      clauses_text:'',
      input_ages:'',
      travellers_number:'',
      selectedLanguage:'',
      name:'',
      emailValue:'',
      PasswordValue:'',
      passwordCon:'',
      first_name:'',
      last_name:'',
      address:'',
      landMark:'',
      pincode:'',
      twitterUrl:'',
      facebookUrl:'',
      googleUrl:'',
      linkedinUrl:'',
      city:'',
      required,
      email,
      codeIcon,
      customer_zip_code:'',
      customer_school:'',
      check_product:'',
      document_number:'',
      document_authority_certification:'',
      trip_info_text:'',
      arrival_city:'',
      travel_price:'',
      selectedTitle: null,
      customTitle:'',
      traveller_select:[
        { value: 'Mr.', text: 'Mr' },
        { value: 'Mrs.', text: 'Mrs' },
        { value: 'Miss', text: 'Miss' },
        { value: 'Ms', text: 'Ms' },
        { value: 'Mx', text: 'Mx' },
        { value: 'Dr', text: 'Dr' },
        { value: 'Prof', text: 'Prof' },
        { value: 'Rev', text: 'Rev' },
        { value: 'Sir', text: 'Sir' },
        { value: 'Lady', text: 'Lady' },
        { value: 'Lord', text: 'Lord' },
        { value: 'Master', text: 'Master (for boys under 14)' },
        { value: 'MissChild', text: 'Miss (for girls under 14)' },
        { value: 'Other', text: 'Other' }
      ],
      contractedPartyType:[
        {value: 'no', text: 'No (policy holder is an individual)'},
        {value: 'yes', text: 'Yes (policy holder is a company)'},
      ],
      contractedPartyTypeSelected:[
        {value: 'no', text: 'No (policy holder is an individual)'}
      ],
      documentType:[
        {value: 'afm', text: 'Tax ID Number'},
        {value: 'adt', text: 'National ID'},
        {value: 'passport', text: 'Passport'},
      ],
      documentAuthority:[
        {value: 'afm', text: 'Tax ID Number'},
        {value: 'adt', text: 'National ID'},
        {value: 'passport', text: 'Passport'},
      ],
      documentTypeSelected:[
        {value: 'afm', text: 'Tax ID Number'}
      ],
      documentAuthoritySelected:[
        {value: 'afm', text: 'Tax ID Number'}
      ],
      countrysFrom, 
      countrysTo, 
      countryVia,
      product_documents,
      euCountries,
      agentName:[
        {value:'314', text:'pallidis@icloud.com'}
      ],
      behalfOf:[
        {value:'248', text:'Vasilis Pallidis Insurance Brokers'}
      ],
      clausesArr:[
        {value:'Covid-19 - The exclusion of Covid-19 is restricted to the Cancellation / Curtailment section only, which means that emergency medical expenses and other losses will not be declined under the Covid-19 exclusion.', id:'Covid-19', text:'Covid-19'},
        {value:`Business Travel Clause - In addition to general Terms & conditions, this insurance policy covers a Business trip and the below coverages are valid during business activity as well, as per attached Schedule of benefits, and always subject and prior to Underwriters approval. 

        Cover Description                 Sums Insured / Level of Benefit               Excess Each & Every Claim

        Employee Replacement                      EUR 5,000.00                                                   Nil 

        Business Equipment                           EUR 5,000.00                                          EUR 100 excess

        Money                                                 EUR 3,000.00                                           EUR 100 excess

        Business Trip Supplement Cover

        Business Equipment

        WHAT IS COVERED

        1.    Business Equipment

        We will reimburse You up to the sum insured shown in the above Table in respect of the cost of the repair or replacement for Business Equipment in Your care, custody or control which is lost, damaged, stolen or destroyed.

        2.    Business Documents and Records

        We will indemnify You up to the sum insured shown in the Schedule of Benefits Table in respect of the cost of replacing or restoring business documents and records which are Your property or responsibility, following loss or damage during the Trip.

        DEFINITIONS

        Business Equipment

        Any business equipment, trade samples, or articles which belong to You and are in Your custody and are taken on or acquired during a business trip undertaken by You.

        WHAT WE DO NOT COVER

        1.       the Excess amount shown in the Schedule of Benefits Table.

        2.    damage due to wear and tear or gradual deterioration.

        3.    loss of or damage to household effects.

        4.    electrical or mechanical breakdown or derangement.

        5.    loss or damage to Valuables contained in baggage whilst such baggage is in the custody of Carriers and outside Your control.

        6.    theft or attempt of theft of Valuables when they are unattended other than when securely locked in a building or securely locked out of sight inside a motor vehicle.

        7.    loss of cash, currency, bank notes, travellers' cheques, passports, driving licenses, green card, petrol coupons, tickets, ski passes, securities and documents.

        8.    confiscation or detention by Customs or other Authority.

        Business Money

        WHAT IS COVERED

        We will reimburse You, up to an amount not exceeding the sum insured shown in the Schedule of Benefits Table, if during the Trip, Business Money is lost, stolen or destroyed.

        DEFINITIONS

        Business Money

        Coins, bank and currency notes, postal orders, signed travellers' and other cheques, letters of credit, travel tickets, current postage stamps, credit cards and petrol and other coupons, driving licence, and green card.

        WHAT WE DO NOT COVER

        1.       the Excess amount shown in the Schedule of Benefits Table.

        2.    any loss not reported to the Police within 48 hours of discovery.

        3.    Business Money lost in exchange, or through errors or omissions in transactions or purchases.

        4.    loss of Business Money contained in baggage whilst such baggage is in the custody of Carriers and outside Your control.

        5.    confiscation or detention by Customs or other authority.

        6.    any loss in respect of the fraudulent use of credit card, charge card or bankers' card comprising Business Money if You have not complied with the terms and conditions under which the card was issued, including those relating to the safe-keeping and use of the card and the reporting to the Issuing Company or Bank of any misplacement or loss.`, id:'Business_Travel_Clause', text:'Business Travel Clause'},
        {value:`People Already Travelling - Τhere is an  inclusion of a 72 hour waiting period and deletion of the cooling off period in terms of a refund of any premium in the event that the policy is cancelled`, id:'People_Already_Travelling', text:'People Already Travelling'},
        {value:`Excess Waiver Extension Endorsement - Excess Waiver Option is Valid`, id:'Excess_Waiver_Extension_Endorsement', text:'Excess Waiver Extension Endorsement'}
      ],
      resCheckName:null,
      destCheckName:null,
      agesArr:[],
      travellers:[],
      initialRequest:{},
      travellerAges:'',
      updateTravellersFlag:false,
      totalDays:null,
      companyNameDisabled:true,
      product_price:[],
      product_currency:[],
      product_currency_symbol:[],
      product_category:[],
      product_code:[],
      product_description:[],
      product_name:[],
      product_short_description:[],
      primary:null,
      secondary:null,
      previousQuotations:[],
      storageQuote:null,
      sliderStatus:false,
    }
  },
  computed: {
    cookie() {
      return window?.$cookies?.get("jwt") ?? null;
    },
    token_id() {
      return this.$store.state.app?.userData?.id ?? null
    },
    ls_role() {
      return this.$store.state.app?.userData?.role ?? 'client'
    },
    ls_scope() {
      return this.$store.state.app?.userData?.scope ?? ''
    },
    ls_company_name() {
      return this.$store.state.app?.userData?.fullName ?? ''
    },
    offerBtnState() {
      return this.showProducts && this.ajax_products.length > 0 && this.showSaveOfferButton
    },
    isAllYes() {
      return (
        this.selected_coverages === 'A' &&
        this.selected_treatment === 'A' &&
        this.selected_medical === 'A' &&
        this.consent_pd === 'A' &&
        this.confirm_plword === 'A' &&
        this.confirm_prv_plcy === 'A'
      );
    },
    productsMsg() {
      return this.$t(`message.select_tr_ins`);
    },
    getQuoteMsg() {
      return this.$t(`message.get_quote_err`);
    },
    one_day() {
      return this.$t("message.one_day");
    },
    more_days() {
      return this.$t("message.more_days");
    },
    please_wait() {
      return this.$t("message.please_wait");
    },
    buy_policy_text() {
      return this.$t("message.buy_policy");
    },
    date_range() {
      return this.$t("message.date_range");
    },
    date_of_birth() {
      return this.$t("message.date_of_birth");
    },
    date_between() {
      return this.$t("message.date_between");
    }
  },
  methods: {
    handleNotifyOk() {
      window.location.reload();
    },
    async handleMedicalFormSubmit(formData) {
      this.medical_form_errors = {}; // Clear old errors
      const errors = this.validateMedicalForm(formData);
      if (Object.keys(errors).length > 0) {
        this.medical_form_errors = errors;
        return;
      }
      // console.warn(formData)
      const result = await this.submitMedicalForm(formData);

      if (!result.ok) {
        this.medical_form_errors = result.errors || {};
        return;
      }

      if (result?.status === 'success') {
        // CLOSE MODAL
        this.modal_medeclaration = false;
        // SUCCESS MESSAGE
        this.modal_notify=true;
      }
    },
    validateMedicalForm(form) {
      const errors = {};
      
      // ===== BASIC FIELDS =====
      if (!form.email || !form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        errors.email = 'Valid email is required';
      }
      if (!form.country || form.country.length < 3) {
        errors.country = 'Country must be at least 3 characters';
      }
      if (!form.address || form.address.length < 3) {
        errors.address = 'Address must be at least 3 characters';
      }
      if (!form.mobile || form.mobile.length < 6) {
        errors.mobile = 'Mobile must be at least 6 characters';
      }
      if (!form.destination || form.destination.length < 3) {
        errors.destination = 'Destination must be at least 3 characters';
      }
      if (!form.conditions || form.conditions.length < 3) {
        errors.conditions = 'Conditions must be at least 3 characters';
      }
      if (!form.policy_type) {
        errors.policy_type = 'Policy type is required';
      }
      if (!form.policy_cover) {
        errors.policy_cover = 'Policy cover is required';
      }
      if (form.cost && isNaN(parseFloat(form.cost))) {
        errors.cost = 'Cost must be a valid number';
      }
      
      // ===== SIGNATURE =====
      if (!form.signature || form.signature.length < 6) {
        errors.signature = 'Signature must be at least 6 characters';
      }

      // ===== OPTIONAL TEXT FIELDS =====
      // These can be empty but if provided should have some content
      if (form.telephone && form.telephone.length < 6) {
        errors.telephone = 'Telephone must be at least 6 characters';
      }
      if (
        form.hazardous_activities &&
        !Array.isArray(form.hazardous_activities)
      ) {
        errors.hazardous_activities = 'Hazardous activities must be an array';
      }
      if (form.special_requests && typeof form.special_requests !== 'string') {
        errors.special_requests = 'Special requests must be text';
      }
      
      // ===== DATES =====
      if (!form.start_date) {
        errors.start_date = 'Start date is required';
      }
      if (!form.end_date) {
        errors.end_date = 'End date is required';
      }
      if (form.end_date && form.start_date && new Date(form.end_date) <= new Date(form.start_date)) {
        errors.end_date = 'End date must be after start date';
      }
      
      // ===== TRAVELLERS =====
      if (!form.travellers || form.travellers.length === 0) {
        errors.travellers = 'At least one traveller is required';
        return errors;
      }
 
      form.travellers.forEach((traveller, index) => {
        if (!traveller.title) {
          errors[`traveller_${index}_title`] = `Traveller ${index + 1}: Title is required`;
        }
        if (!traveller.firstname || traveller.firstname.length < 3) {
          errors[`traveller_${index}_firstname`] = `Traveller ${index + 1}: First name must be at least 3 characters`;
        }
        if (!traveller.lastname || traveller.lastname.length < 3) {
          errors[`traveller_${index}_lastname`] = `Traveller ${index + 1}: Last name must be at least 3 characters`;
        }
        if (!traveller.dob) {
          errors[`traveller_${index}_dob`] = `Traveller ${index + 1}: Date of birth is required`;
        }
        if (traveller.age === null || traveller.age === '') {
          errors[`traveller_${index}_age`] = `Traveller ${index + 1}: Age is required`;
        }
 
        // Age vs DOB consistency
        if (traveller.age && traveller.dob) {
          const today = new Date();
          const birthDate = new Date(traveller.dob);
          let age = today.getFullYear() - birthDate.getFullYear();
          const m = today.getMonth() - birthDate.getMonth();
 
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
 
          if (Math.abs(age - parseInt(traveller.age)) > 1) {
            errors[`traveller_${index}_age`] = `Traveller ${index + 1}: Age does not match date of birth`;
          }
        }
      });
      
      // ===== DECLARATIONS =====
      if (form.declarations.introduction !== true) {
        errors.introduction = 'You must accept the introduction statement';
      }
      if (form.declarations.coverage !== true) {
        errors.coverage = 'You must accept the coverage statement';
      }
      
      // ===== QUESTIONS =====
      const questionKeys = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'];
      questionKeys.forEach((key) => {
        if (form.questions[key] !== true) {
          errors[key] = `Question ${key.charAt(1)} requires "Yes" to proceed`;
        }
      });
      
      return errors;
    },
    async submitMedicalForm(data) {
      const payload = {
        ...data,
        token: this.token_id,
        jwt: this.cookie
      };
      try {
        const response = await fetch("https://api-quote.safetravel.today/v2/app/create_medical_form", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
 
        const result = await response.json().catch(() => ({}));
 
        if (response.status === 401) {
          performLogoutWithoutRedirect(this.$store);
          return { ok: false, errors: ['Unauthorized'] };
        }
 
        if (response.status === 422) {
          return {
            ok: false,
            errors: result?.errors || ['Validation failed'],
          };
        }
 
        if (!response.ok) {
          return {
            ok: false,
            errors: [result?.message || `Server error: ${response.status}`],
          };
        }
        
        if (result?.status === 'success') {
          return { ok: true, status: 'success', medical_form_id: result.medical_form_id };
        }
 
        return { ok: false, errors: ['Unexpected response'] };
      } catch (err) {
        console.error('Submit error:', err);
        return { ok: false, errors: ['Network error'] };
      }
    },
    isSelectableCountry(option) {
      if (this.ls_role === 'admin') return true
      const value = option?.value
      if (!value) return false
      return (
        !this.blockedCountryIds.includes(value) &&
        !value.includes('To...')
      )
    },
    isSelectableViaCountry(option) {
      if (this.ls_role === 'admin') return true
      const value = option?.value ?? option
      if (!value) return false
      return (
        !this.blockedCountryIds.includes(String(value)) &&
        !String(value).includes('To...')
      )
    },
    onSearchBlur() {
      this.$refs.viaSelect.search = ''
    },
    clearExcel() {
      this.excelUploaded = false;
      this.excelFile = null;
      this.input_ages = '';
      this.numberoftravellers = [];
      this.dateBirthLabel = [];
      this.agesArr = [];
      this.travellerData = [];
      this.travellers = [];
      this.initialRequest.travellers = [];
      this.initialRequest.ages = '';
      this.updateTravellersFlag = false;
      this.updateAges([], []);
      this.duplicatecommas = null;
      this.adult_supervisor = null;
      // this.onAgesBlur();
    },
    handleExcelUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      // Helper to replace month names with numbers and normalize separators
      const replaceMonthNames = (dateStr) => {
        if (!dateStr) return dateStr;

        const monthMap = {
          jan: '01', feb: '02', mar: '03', apr: '04', may: '05', jun: '06',
          jul: '07', aug: '08', sep: '09', oct: '10', nov: '11', dec: '12'
        };

        let result = dateStr.toString().trim().toLowerCase();

        // Replace full month names (January, February...)
        result = result.replace(/\b(january|february|march|april|may|june|july|august|september|october|november|december)\b/g, (m) => {
          return monthMap[m.slice(0,3)] || m;
        });

        // Replace short month names (jan, feb, mar...)
        result = result.replace(/\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/g, (m) => {
          return monthMap[m] || m;
        });

        // Normalize separators to '-'
        result = result.replace(/[\/\.]/g, '-');

        return result;
      };

      const normalizeTitle = (title) => {
        if (!title) return 'Mr.';

        const t = title.toString().trim().toLowerCase();

        // Determine default based on common gender indicators
        let defaultTitle = 'Mr.';
        if (t === 'f' || t === 'female') {
          defaultTitle = 'Mrs.';
        } else if (t === 'm' || t === 'male')  {
          defaultTitle = 'Mr.';
        }

        // Match input to either text or value (with or without dot)
        const option = this.traveller_select.find(opt => {
          const valueLower = (opt.value || '').toString().trim().toLowerCase();
          const textLower = (opt.text || '').toString().trim().toLowerCase();
          return t === valueLower || t === valueLower.replace('.', '') || t === textLower;
        });

        // Return the value (Mr., Mrs., Miss, etc.)
        return option ? option.value : defaultTitle;
      };

      // Parse DOB from string or Excel serial number
      const parseDOB = (value) => {
        if (!value) return null;

        if (typeof value === 'number') {
          // Excel serial date to JS date (Excel epoch starts at 1899-12-30)
          const jsDate = new Date((value - 25569) * 86400 * 1000);
          return moment(jsDate);
        }

        // Normalize separators and month names
        let normalized = replaceMonthNames(value.toString().trim());

        // Handle formats like M/D/YYYY or MM/D/YYYY → pad to DD-MM-YYYY attempt
        const mdyyyy = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
        if (mdyyyy.test(normalized)) {
          const [_, a, b, year] = normalized.match(mdyyyy);

          // Try DD-MM-YYYY first (your system uses this)
          const dd = a.padStart(2, "0");
          const mm = b.padStart(2, "0");

          const tryDDMM = `${dd}-${mm}-${year}`;
          const parsedDDMM = moment(tryDDMM, "DD-MM-YYYY", true);
          if (parsedDDMM.isValid()) return parsedDDMM;

          // Fallback: interpret as MM-DD-YYYY
          const tryMMDD = `${mm}-${dd}-${year}`;
          const parsedMMDD = moment(tryMMDD, "MM-DD-YYYY", true);
          if (parsedMMDD.isValid()) return parsedMMDD;
        }


        // Accept only these formats, strict parsing
        const formats = [
          "DD-MM-YYYY",
          "MM-DD-YYYY",
          "YYYY-MM-DD",
          "DD/MM/YYYY",
          "MM/DD/YYYY"
        ];
        const parsed = moment(normalized, formats, true);
        return parsed.isValid() ? parsed : null;
      };

      reader.onload = (e) => {
        this.excelUploaded = true;
        this.duplicatecommas = null;
        this.adult_supervisor = null;
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet);

        const requiredColumns = ['First Name', 'Last Name', 'Date of Birth'];
        const firstRow = rows[0] || {};

        const normalizeKeys = (obj) => {
          const result = {};
          Object.keys(obj).forEach(k => result[k.trim().toLowerCase()] = obj[k]);
          return result;
        };

        const normalizedFirstRow = normalizeKeys(firstRow);
        for (const col of requiredColumns) {
          if (!(col.toLowerCase() in normalizedFirstRow)) {
            this.resetTravellers(`Missing required column: ${col}`);
            return;
          }
        }

        const validRows = rows
          .map(row => normalizeKeys(row))
          .filter(row => Object.values(row).some(v => String(v).trim() !== ''));

        if (!validRows.length) {
          this.resetTravellers("Excel: No traveller rows found.");
          return;
        }

        const getCell = (row, col) => row[col.toLowerCase()];
        const travellerData = [];
        const ages = [];
        const errors = [];

        validRows.forEach((row, i) => {
          const rowNo = i + 2; // +1 header, +1 για 1-based
          const firstname = (getCell(row, 'first name') || '').toString().trim();
          const middlename = (getCell(row, 'middle name') || '').toString().trim();
          const lastname = (getCell(row, 'last name') || '').toString().trim();
          const mobile = (getCell(row, 'mobile') || '').toString().trim();

          if (!firstname || !lastname) {
            errors.push(`Row ${rowNo}: First Name and Last Name are required`);
            return;
          }

          const rawDOB = getCell(row, 'dob') || getCell(row, 'date of birth');
          if (!rawDOB) {
            errors.push(`Row ${rowNo}: Date of Birth is required`);
            return;
          }

          const dobMoment = parseDOB(rawDOB);
          if (!dobMoment) {
            errors.push(`Row ${rowNo}: Invalid Date of Birth "${rawDOB}"`);
            return;
          }

          const age = this.getAge(dobMoment.format("DD-MM-YYYY"));
          if (isNaN(age) || age < 0 || age > 99) {
            errors.push(`Row ${rowNo}: Age must be between 0 and 99`);
            return;
          }

          ages.push(age);
          travellerData.push({
            id: `${i}`,
            title: normalizeTitle(getCell(row, 'title')).trim(),
            firstname: firstname + (middlename ? ' ' + middlename : ''),
            lastname,
            date: dobMoment.toDate(),
            age,
            mobile
          });
        });

        if (errors.length) {
          const shown = errors.slice(0, 5).join(' | ');
          const more = errors.length > 5 ? ` (+${errors.length - 5} more)` : '';
          this.resetTravellers(`Excel: ${shown}${more}`);
          return;
        }

        if (!ages.some(this.checkAdult) && this.ls_role != 'admin') {
          this.resetTravellers("Excel: At least one adult supervisor is required.");
          return;
        }

        this.input_ages = ages.join(', ');
        this.agesArr = ages;
        this.travellerData = travellerData;

        this.updateAges(ages, travellerData);
        this.addTravellers();
      };

      reader.readAsArrayBuffer(file);
    },
    updateInitialRequest(data) {
      this.showofferwaring = !!(data && Array.isArray(data.selectedOptions) && data.selectedOptions.length > 0);
      this.initialRequest['addons'] = data?.selectedOptions ?? []
      this.initialRequest['price_product_addon_sompo'] = data?.totalPrice ?? 0;
      // console.error(this.initialRequest)
    },
    toggleCoverage() {
      this.showCoverage = !this.showCoverage;
    },
    removeDobHighlight(i) {
      this.$set(this.dobHighlightFlags, i, false);
    },
    async saveOffer(data) {
      this.offersavebtn = true;
      const url= {
          prod: 'https://api-quote.safetravel.today/v2/app/insert_offer'
      };
      try {
        await fetch(url.prod, {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
      })
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to save offer: HTTP ${response.status}`);
        return response.json();
      })
      .then((res)=>{
        if (res === 'not_valid') {
          performLogoutWithoutRedirect(this.$store)
          return;
        }
        this.offermessagemodalshow=true;
      })
      } catch (error) {
        // TypeError: Failed to fetch
        console.warn('There was an error, couldnt save offer', error);
        this.errorSOffer = 'An error occurred while saving the offer. Please try again later.';
      } finally {
        this.offersavebtn = false;
       }
    },
    async handleOfferSubmit() {
      const valid = this.$refs.offerForm.checkValidity()
      if (localStorage.getItem("checkedProducts") === null) {
        this.errorSOffer="No product(s) has beed added to offer"
        return
      }
      if (!valid) {
        this.errorSOffer="Offer name must be at least 6 characters long"
      } else {
        this.sv_offer["token"] = this.token_id
        this.sv_offer["app"] = "true"
        this.sv_offer["name"] = this.offerName
        if (localStorage.getItem("checkedProducts") !== null) {
          this.sv_offer['offered_products'] = localStorage.getItem("checkedProducts")
        }
        this.sv_offer["trip_information"] = JSON.stringify(this.initialRequest)
        this.sv_offer["jwt"] = this.cookie
        // save offer
        await this.saveOffer(this.sv_offer);
        return !this.errorSOffer;
      }
      return valid;
    },
    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault() // always prevent first
      
      const valid = await this.handleOfferSubmit();
      if (valid) {
        // only close if save succeeded
        this.$nextTick(() => {
          this.$bvModal.hide('modal-offer')
        });
      }
    },
    formatDate(d) {
      if (d.split("-")[0].length === 4) {
        d = d.split("-").reverse().join('/')
      } 
      return d;
    },
    savedQuotation() {
      try {
        const raw = localStorage.getItem("quote_info");
        if (!raw) return;

        const info = JSON.parse(raw);
        if (!info) return;

        this.initialRequest = { ...info };

        // From Country
        this.countrysFrom.forEach((res) => {
          if (res.value == info?.residence) {
            this.selectedContryFrom = res.text;
            this.fromCountryfHidden = res.text;
            this.initialRequest['res_name'] = res.text;
            this.initialRequest['residence'] = Number(res.value);
          }
        });

        // To Country
        this.countrysTo.forEach((dest) => {
          if (dest.value == info?.destination) {
            this.selectedContryTo = dest.text;
            this.toCountryfHidden = dest.text;
            this.initialRequest['des_name'] = dest.text;
            this.initialRequest['destination'] = Number(dest.value);
          }
        });

        // Parse ages
        const ages = info.ages?.split(',').map(age => Number(age.trim())) || [];

        // Sync to UI state
        this.input_ages = info.ages;
        this.travellers_number = ages.length;
        this.selectedContryFrom = info.res_name;
        this.fromCountryfHidden = info.res_name;
        this.selectedContryTo = info.des_name;
        this.toCountryfHidden = info.des_name;

        // Update input field manually if still needed
        const inputEl = document.querySelector("#input_ages");
        if (inputEl) inputEl.value = info.ages;

        this.updateAges(ages);
        this.addTravellers(ages);

        // Dates
        const sDate = this.formatDate(info.sdate);
        const eDate = this.formatDate(info.edate || info.sdate);

        const now = moment(new Date(), "DD/MM/YYYY").toDate();
        const start = moment(sDate, "DD/MM/YYYY").toDate();
        const end = moment(eDate, "DD/MM/YYYY").toDate();

        this.range.start = now > start ? now : start;
        this.range.end = now > end ? now : end;
        this.datePickerKey++;

        this.viastate = false;
        localStorage.removeItem("quote_info");
      } catch (error) {
        console.error("Error in savedQuotation:", error);
      }
    },
    savedQuotationApp() {
      try {
        const raw = localStorage.getItem("quote_info_app");
        if (!raw) return;

        const info = JSON.parse(raw);
        if (!info) return;

        // DON'T put addons in initialRequest here - they'll be handled by child components
        this.initialRequest = { ...info };
        delete this.initialRequest.addons; // Remove addons from API request
        delete this.initialRequest.price_product_addon_sompo; // Remove addon price

        // sync other component properties for UI
        if (!info.ages) return;
        this.input_ages = info.ages;
        const ages = info.ages.split(',').map(age => Number(age.trim()));

        this.travellers_number = info.travellersNumber;
        this.toCountryfHidden = info.des_name;
        this.selectedContryFrom = info.res_name;
        this.fromCountryfHidden = info.res_name;
        this.selectedContryTo = info.des_name;
        // Map via_countries (strings) back to full objects for v-select
        if (info.via_countries?.length > 0) {
          this.selectedVia = this.countryVia.filter(country =>
            info.via_countries.includes(country.text)
          );
        } else {
          this.selectedVia = [];
        }
        this.updateAges(ages);
        this.addTravellers(ages);

        // Dates
        const sDate = this.formatDate(info.start_date);
        const eDate = this.formatDate(info.end_date || info.start_date);

        const now = moment(new Date(), "DD/MM/YYYY").toDate();
        const start = moment(sDate, "DD/MM/YYYY").toDate();
        const end = moment(eDate, "DD/MM/YYYY").toDate();

        this.range.start = now > start ? now : start;
        this.range.end = now > end ? now : end;
        this.datePickerKey++;

        this.viastate = false;
        localStorage.removeItem("quote_info_app");
      } catch (error) {
        console.error("Error in savedQuotationApp:", error);
      }
    },
    removeQuoteInfoReload() {
      // remove localStorage items on page reload
      window.addEventListener("beforeunload", function(e) {
        if (localStorage.getItem("quote_info") !== null) {
          localStorage.removeItem("quote_info");
        }
        if (localStorage.getItem("quote_info_app") !== null) {
          localStorage.removeItem("quote_info_app");
        }
        if (localStorage.getItem("checkedProducts") !== null) {
          localStorage.removeItem("checkedProducts");
        }
      }); 
    },
    enableSliderScroll() {
      this.sliderStatus = true;
    },
    disableSliderScroll() {
      this.sliderStatus = false;
    },
    initSliderDrag() {
      const slider = document.querySelector('#products_panel_list');
      if (!slider || slider._dragSetup) return;

      let mouseDown = false;
      let startX, scrollLeft;

      const startDragging = (e) => {
        mouseDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      };
      const stopDragging = () => {
        mouseDown = false;
      };
      const dragMove = (e) => {
        if (!mouseDown) return;
        const x = e.pageX - slider.offsetLeft;
        const scroll = x - startX;
        slider.scrollLeft = scrollLeft - scroll;
      };

      slider.addEventListener('mousedown', startDragging);
      slider.addEventListener('mouseup', stopDragging);
      slider.addEventListener('mouseleave', stopDragging);
      slider.addEventListener('mousemove', dragMove);

      slider._dragSetup = { startDragging, stopDragging, dragMove };
    },
    removeSliderDrag() {
      const slider = document.querySelector('#products_panel_list');
      if (!slider || !slider._dragSetup) return;

      const { startDragging, stopDragging, dragMove } = slider._dragSetup;
      slider.removeEventListener('mousedown', startDragging);
      slider.removeEventListener('mouseup', stopDragging);
      slider.removeEventListener('mouseleave', stopDragging);
      slider.removeEventListener('mousemove', dragMove);

      delete slider._dragSetup;
    },
    scrollSliderLeft() {
      const slider = document.querySelector('#products_panel_list');
      if (slider) {
        // Determine the scroll distance based on screen size
        const scrollDistance = window.innerWidth <= 768 ? 200 : 500; // 200px for smaller screens, 500px for larger
        slider.scrollBy({ left: -scrollDistance, behavior: 'smooth' });
      }
    },
    scrollSliderRight() {
      const slider = document.querySelector('#products_panel_list');
      if (slider) {
        // Determine the scroll distance based on screen size
        const scrollDistance = window.innerWidth <= 768 ? 200 : 500; // 200px for smaller screens, 500px for larger
        slider.scrollBy({ left: scrollDistance, behavior: 'smooth' });
      }
    },
    leapYear(year) {
      return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
    },
    newQuotation() {
      window.location.reload();
    },
    async sessionQuotation(name) {
      this.storageQuote=null;
      if (sessionStorage.getItem(name) !== null) {
        const s = sessionStorage.getItem(name);
        this.storageQuote = JSON.parse(s);
        // === CLEAR OLD DATA ===
        this.travellers = [];
        this.numberoftravellers = [];
        this.agesArr = [];
        // token
        this.initialRequest['token']=this.token_id;
        // env
        this.initialRequest['env'] = 'production';
        // From Country
        this.initialRequest['res_name'] = this.storageQuote?.res_name;
        this.fromCountryfHidden = this.storageQuote?.res_name;
        this.selectedContryFrom = this.storageQuote?.res_name;
        this.initialRequest['residence'] = this.storageQuote?.residence;
        // To Country
        this.initialRequest['des_name'] = this.storageQuote?.des_name;
        this.toCountryfHidden = this.storageQuote?.des_name;
        this.selectedContryTo = this.storageQuote?.des_name;
        this.initialRequest['destination'] = this.storageQuote?.destination;
        // enable via, set via
        this.viastate = false;
        this.initialRequest['via_countries'] = this.storageQuote?.via_countries;
        this.initialRequest['via'] = this.storageQuote?.via;
        // via mapping
        this.selectedVia = this.countryVia.filter(country =>
          this.storageQuote?.via_countries?.includes(country.text)
        );
        // Input ages
        this.initialRequest['ages'] = this.storageQuote?.ages;
        this.input_ages = this.storageQuote?.ages;
        // Number of travellers
        this.initialRequest['travellersNumber'] = this.storageQuote?.travellersNumber;
        this.travellers_number = this.storageQuote?.travellersNumber;

        const normalizeTitle = (title) => {
          if (!title) return 'Mr.';
          const t = title.replace(/\./g, ''); // remove any existing dot
          if (t === 'Mr' || t === 'Mrs') return t + '.';
          return t; // leave other titles as-is
        };
        
        for (let i = 0; i < this.storageQuote?.travellers?.length; i++) {
          // this.dateBirthLabel=[];
          this.numberoftravellers.push({
            id:`${i}`, 
            title:normalizeTitle(this.storageQuote?.travellers[i]?.title), 
            firstname: this.storageQuote?.travellers[i]?.firstname, 
            lastname:this.storageQuote?.travellers[i]?.lastname, 
            date: moment(this.storageQuote?.travellers[i]?.dob, "DD/MM/YYYY").toDate(), 
            mobile: this.storageQuote?.travellers[i]?.phone
          })
          this.dateBirthLabel.push({value: this.storageQuote?.travellers[i]?.age, age:new Date(), en:'', gr:'', fr:'', de:'', es:'', it:'', pl:'', ro:''});
          // travellers details
          const traveller={};
          const age = this.storageQuote?.travellers[i]?.age;
          this.agesArr.push(age);
          traveller["title"] = normalizeTitle(this.storageQuote?.travellers[i]?.title) ?? "Mr.";
          traveller["firstname"] = this.storageQuote?.travellers[i]?.firstname ?? "first_test_"+age;
          traveller["lastname"] = this.storageQuote?.travellers[i]?.lastname ?? "last_test_"+age;
          traveller["dob"] = this.storageQuote?.travellers[i]?.dob ?? "dob_"+age;
          traveller["age"] = Number(age);
          this.travellers.push(traveller);
          this.initialRequest['travellers']=this.travellers;
        }
        // start date, end date
        const start = this.storageQuote?.start_date ?? new Date();
        const momentStart = moment(start, "DD/MM/YYYY").toDate();
        const end = this.storageQuote?.end_date ?? new Date();
        this.range.start = moment(start, "DD/MM/YYYY").toDate();
        this.range.end = moment(end, "DD/MM/YYYY").toDate();
        // RECALCULATE days
        const diff = Math.abs(this.range.end - this.range.start);
        const days = Math.ceil(diff / (1000 * 3600 * 24)) + 1;
        this.initialRequest.start_date = start;
        this.initialRequest.end_date   = end;
        this.initialRequest.days       = days;  // ← CRITICAL
        await this.$nextTick();
        this.datePickerKey++;
        // set selected product, tab view
        await this.getQuote();
        await this.$nextTick();
        // === NOW safely click tab ===
        const tab = document.getElementById(`button-tab${this.storageQuote.product}`);
        if (tab) tab.click();
        if (this.storageQuote.product_category === 'Longstay') {
          document.querySelector('.longstaytripbtn')?.click();
        } else if (this.storageQuote.product_category === 'Annual') {
          document.querySelector('.annualtripbtn')?.click();
        }
        // family details
        this.initialRequest['email'] = this.storageQuote?.email ?? '';
        this.initialRequest['school'] = this.storageQuote?.school ?? '';
        this.initialRequest["address"] = this.storageQuote?.city + ", " + this.storageQuote?.area + ", " + this.storageQuote?.street + " " + this.storageQuote?.number ?? '';
        this.initialRequest['street'] = this.storageQuote?.street ?? '';
        this.initialRequest['number'] = this.storageQuote?.number ?? '';
        this.initialRequest['area'] = this.storageQuote?.area ?? '';
        this.initialRequest['city'] = this.storageQuote?.city ?? '';
        this.initialRequest['country'] = this.storageQuote?.country ?? '';
        this.initialRequest["telephone"] 	                        = this.storageQuote?.telephone ?? '';
        this.initialRequest["tax_identification_number"] 	        = this.storageQuote?.tax_identification_number ?? '';
        this.initialRequest["postcode"] = this.storageQuote?.additional_info?.postcode ?? '',

        // additional info, contact details to initialRequest
        this.initialRequest['additional_info']={
          'contracted_party_type' : this.storageQuote?.additional_info?.contracted_party_type ?? 'no',
          'company_name' : this.storageQuote?.additional_info?.company_name ?? '',
          'document_type' : this.storageQuote?.additional_info?.document_type ?? 'afm',
          'document_number' : this.storageQuote?.additional_info?.document_number ?? '',
          'document_authority' : this.storageQuote?.additional_info?.document_authority ?? 'afm',
          'document_authority_certification' : this.storageQuote?.additional_info?.document_authority_certification ?? '',
          'trip_information_text' : this.storageQuote?.additional_info?.trip_information_text ?? '',
          'arrival_city' : this.storageQuote?.additional_info?.city ?? '',
          'travel_price' : this.storageQuote?.additional_info?.travel_price ?? '',
          'postcode' : this.storageQuote?.additional_info?.postcode ?? '',
          'phone' : this.storageQuote?.telephone ?? '',
          'mobile' : this.storageQuote?.telephone ?? '',
          'country' : this.storageQuote?.additional_info?.country ?? '',
          'street' : this.storageQuote?.additional_info?.street ?? '',
          'number' : this.storageQuote?.additional_info?.number ?? '',
          'area' : this.storageQuote?.additional_info?.area ?? '',
          'city' : this.storageQuote?.additional_info?.city ?? '',
        }
        // family form update ui
        this.contact_email = this.initialRequest['email'];
        this.customer_street = this.initialRequest['street'];
        this.street_number = this.initialRequest['number'];
        this.customer_area = this.initialRequest['area'];
        this.customer_city = this.initialRequest['city'];
        this.tax_identification_number = this.initialRequest["tax_identification_number"];
        this.customer_telephone = this.initialRequest["telephone"];
        this.customer_zip_code = this.initialRequest.postcode;
        this.selectedContryPolicyHolder = this.initialRequest['country'];
        // additional info update ui
        this.company_name = this.initialRequest['additional_info'].company_name;
        this.document_number = this.initialRequest['additional_info'].document_number;
        this.document_authority_certification = this.initialRequest['additional_info'].document_authority_certification;
        this.trip_info_text = this.initialRequest['additional_info'].trip_information_text;
        this.arrival_city = this.initialRequest['additional_info'].arrival_city;
        this.travel_price = this.initialRequest['additional_info'].travel_price;
        // addition info update ui select 
        this?.documentAuthority?.forEach((e)=> {
          if(e.value == this.initialRequest['additional_info'].document_authority) {
            this.documentAuthoritySelected = e.text;
          }
        })
        this?.contractedPartyType?.forEach((e)=> {
          if(e.value == this.initialRequest['additional_info'].contracted_party_type) {
            this.contractedPartyTypeSelected = e.text;
          }
        })
        this?.documentType?.forEach((e)=> {
          if(e.value == this.initialRequest['additional_info'].document_type) {
            this.documentTypeSelected = e.text;
          }
        })

      } else {
        window.location.reload();
      }
    },
    checkPreviousQuotations() {
      const arr = [];
      // Get only our keys
      const keys = Object.keys(sessionStorage).filter(key => key.startsWith('initialRequest_'));
      // Sort by timestamp DESC (newest first)
      keys.sort((a, b) => parseInt(b.split('_')[1]) - parseInt(a.split('_')[1]));
      // Build array
      keys.forEach(key => {
        try {
          const data = JSON.parse(sessionStorage.getItem(key));
          const name = data.travellers?.[0]?.lastname || 'User';
          const product = data.product_name || 'Product';
          arr.push([key, `${name} - ${product}`]);
        } catch (e) {
          // Skip corrupted entries
        }
      });
      this.previousQuotations = arr;
    },
    populateFormDts() {
      for(let i=0; i<150; i++) {
        this.loadFormDts[0][`traveller_title${i+1}`] = 'Mr.';
        this.loadFormDts[1][`firstName${i+1}`] = '';
        this.loadFormDts[2][`lastName${i+1}`] = '';
        this.loadFormDts[3][`mobile${i+1}`] = '';
      }
    },
    copylink() {
      const dummy = document.createElement('input');
      navigator.clipboard.writeText(this.hrefpaymentlink);
    },
    async buyProduct(e){
      this.buypolicystatus=false;
      e.target.innerHTML = this.please_wait;
      e.target.disabled = true;
      // if annual, update end_date
      if (this.initialRequest.product_category == 'Annual') {
        this.initialRequest['end_date'] =  this.initialRequest['annual_date'];
      }
      // check sanctions
      const hold = await this.sanctionsHold();
      if (hold) {
        await this.saved_transactions(hold);
        this.paymentmodalerrorshow = true;
        this.buypolicystatus = true;
        this.switched_checked_accept = false;
        e.target.innerHTML = this.buy_policy_text;
        e.target.disabled = false;
        return;
      }

      if (this.ls_scope.includes('app.travel-insurance.purchase')) {
        this.purchaseURL(e);
      } else {
        this.reserveURL(e);
      }
	  },
    async sanctionsHold() {
      try {
        const response = await fetch('https://api-quote.safetravel.today/v2/app/check_sanctions', {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            token: this.initialRequest['token'],
            travellers: (this.initialRequest['travellers'] || []).map(t => ({
              firstname: t.firstname, lastname: t.lastname, dob: t.dob
            }))
          })
        });
        if (!response.ok) return 'Sanctions check failed';
        const res = await response.json();
        if (res.status === 'no_match') return null;
        const names = (res.travellers || [])
          .filter(t => t.matches && t.matches.length)
          .map(t => `${t.first_name} ${t.last_name} ~ ${t.matches[0].full_name} (${t.matches[0].dob_status})`);
        return names.length ? 'Sanctions: ' + names.join('; ') : 'Sanctions check: ' + res.status;
      } catch (err) {
        console.warn(err);
        return 'Sanctions check failed';
      }
    },
    async saved_transactions(reason = null) {
      const url = 'https://api-quote.safetravel.today/v2/app/saved_transactions';
      const data = {
        product: this.initialRequest['product'] + ":" + this.initialRequest['price'] + '€',
        trip_information: JSON.stringify(this.initialRequest),
        token: this.initialRequest['token'],
        app: 'erp',
        reason
      };
      const isHold = !!reason;
      try {
        const response = await fetch(url, {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error(`Failed to save transaction: HTTP ${response.status}`);
        const res = await response.json();
        if (!res || res === 'not_valid') throw new Error('Saved transactions returned an invalid result');

        this.errorbuyProductModalMsg = isHold
          ? this.$t('message.application_under_review')
          : this.$t('message.transaction_saved');
        return true;
      } catch (err) {
        console.warn(err);
        this.errorbuyProductModalMsg = this.$t('message.application_contact_us');
        return false;
      }
    },
    async purchaseURL(e) {
      const url = 'https://api-quote.safetravel.today/v2/s360/purchase';
      const paymentOrderUrl = 'https://api-quote.safetravel.today/v2/app/payment-order/generate';
      
      try {
        // First API call
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.initialRequest),
        });

        if (!response.ok) {
          this.buypolicystatus = false;
          this.paymentmodalerrorshow = true;
          this.errorbuyProductModalMsg = `API request failed with status ${response.status}. Please try again later.`;
          this.saved_transactions();
          e.target.innerHTML = this.buy_policy_text;
          e.target.disabled = false;
          return;
        }

        const result = await response.json();

        if (result.error || !result?.token) {
          this.errorbuyProductModalMsg = result.error || 'Unexpected response. Please try again later.';
          this.paymentmodalerrorshow = true;
          e.target.innerHTML = this.buy_policy_text;
          e.target.disabled = false;
          return;
        }

        // Display logic
        this.display_payment_ammount = result.payable_here !== '-';
        this.display_reserve_msg = false;
        this.display_purchase_msg = true;
        
        // Validate transaction_id before pushing
        const transactionId = Number(result.transaction_id);
        if (isNaN(transactionId)) {
          throw new Error('Invalid transaction ID received');
        }
        const transaction_ids = [transactionId];

        this.displayproduct = this.initialRequest?.product_name || 'Unknown Product';
        this.displayprice = result?.gross_price ? `${result.gross_price}€` : 'N/A';
        this.payablefrom = result?.payable_from || 'N/A';
        this.payableto = result?.payable_to || 'N/A';

        // Validate token_id
        if (!this.token_id) {
          throw new Error('Token ID is missing');
        }

        // Second API call
        const data_viva = {
          token: this.token_id,
          env: 'production',
          transaction_ids,
        };
        const vivaResponse = await fetch(paymentOrderUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data_viva),
        });

        if (!vivaResponse.ok) {
          throw new Error(`Payment order API failed with status ${vivaResponse.status}`);
        }

        const vivaResult = await vivaResponse.json();
        const amount = vivaResult?.payment_order?.paymentOrder?.amount
          ? (vivaResult.payment_order.paymentOrder.amount / 100).toFixed(2)
          : null;

        if (!amount || !vivaResult?.payment_order?.checkoutUrl) {
          throw new Error('Invalid payment order response');
        }

        // Display modal
        this.payableamount = `${amount}€`;
        this.hrefpaymentlink = vivaResult.payment_order.checkoutUrl;
        this.paymentdts = true;
        this.paymentmodalshow = true;
        this.buypolicystatus = true;
        e.target.innerHTML = this.buy_policy_text;
        e.target.disabled = false;
      } catch (error) {
        console.error('Error in purchaseURL:', error);
        this.errorbuyProductModalMsg = error.message || 'An error occurred. Please try again.';
        this.paymentmodalerrorshow = true;
        e.target.innerHTML = this.buy_policy_text;
        e.target.disabled = false;
      }
    },
    async reserveURL(e) {
      const url = 'https://api-quote.safetravel.today/v2/app/reserve';

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.initialRequest),
        });

        if (!response.ok) {
          this.buypolicystatus = false;
          this.paymentmodalerrorshow = true;
          this.errorbuyProductModalMsg = `API request failed with status ${response.status}. Please try again later.`;
          this.saved_transactions();
          e.target.innerHTML = this.buy_policy_text;
          e.target.disabled = false;
          return;
        }

        const result = await response.json();

        if (result.error || !result?.token) {
          this.errorbuyProductModalMsg = result.error || 'Unexpected response. Please try again later.';
          this.paymentmodalerrorshow = true;
          e.target.innerHTML = this.buy_policy_text;
          e.target.disabled = false;
          return;
        }

        // Display logic
        this.display_payment_ammount = result.payable_here !== '-';
        this.display_reserve_msg = true;
        this.display_purchase_msg = false;

        // Assign UI properties with fallbacks
        this.displayproduct = this.initialRequest?.product_name || 'Unknown Product';
        this.displayprice = result.gross_price ? `${result.gross_price}€` : 'N/A';
        this.payablefrom = result.payable_from || 'N/A';
        this.payableto = result.payable_to || 'N/A';
        this.payableamount = result.payable_amount ? `${result.payable_amount}€` : 'N/A';
        this.hrefpaymentlink = result.payable_here || '';

        // Update modal and button states
        this.paymentdts = true;
        this.paymentmodalshow = true;
        this.buypolicystatus = true;
        this.switched_checked_accept = false;
        e.target.innerHTML = this.buy_policy_text;
        e.target.disabled = false;
      } catch (error) {
        console.error('Error in reserveURL:', error);
        this.errorbuyProductModalMsg = 'An error occurred during reservation. Please try again.';
        this.paymentmodalerrorshow = true;
        e.target.innerHTML = this.buy_policy_text;
        e.target.disabled = false;
      }
    },
    checkIfProducts(cat) {
      if(!document.querySelectorAll(cat).length) {
        this.noProducrsAlert();
      }
    },
    showSelectedTypeProducts(elem,removetypeone,removetypetwo) {
      const rem_classes = [removetypeone, removetypetwo];
      const single = document.querySelector('.singletripbtn');
      const longstay = document.querySelector('.longstaytripbtn');
      const annual = document.querySelector('.annualtripbtn');

      if (elem) {
        if (elem.target.classList.contains("singletripbtn")) {
          single.classList.add('active');
          longstay.classList.remove('active');
          annual.classList.remove('active');
          this.checkIfProducts(".SingleTrip");
        }else if (elem.target.classList.contains("longstaytripbtn")) {
          longstay.classList.add('active');
          single.classList.remove('active');
          annual.classList.remove('active');
          this.checkIfProducts(".Longstay");
        }
        if (elem.target.classList.contains("annualtripbtn")) {
          annual.classList.add('active');
          single.classList.remove('active');
          longstay.classList.remove('active');
          this.checkIfProducts(".Annual");
        }
      } else {
        single.classList.add('active');
        longstay.classList.remove('active');
        annual.classList.remove('active');
        this.checkIfProducts(".SingleTrip");
      }
      document.querySelectorAll(".product_col").forEach((e,i)=> {
        if (rem_classes.some(classname=>e.classList.contains(classname))) {
          e.classList.add("d-none");
        } else {
          e.classList.remove("d-none");
        }
      })

    },
    setContractedPartyType(e) {
      if (e.value == 'yes') {
        this.setcompanyName = true;
      } else {
        this.setcompanyName = false;
      }
      this.companyNameDisabled = !this.companyNameDisabled;
    },
    evaluateBuyPolicyStatus() {
      const isAllYes =
        this.selected_coverages === 'A' &&
        this.selected_treatment === 'A' &&
        this.selected_medical === 'A' &&
        this.consent_pd === 'A' &&
        this.confirm_plword === 'A' &&
        this.confirm_prv_plcy === 'A';

      this.checkpolicystatus = !isAllYes;

      if (!isAllYes && this.switched_checked_accept) {
        this.switched_checked_accept = false;
      }

      this.buypolicystatus = !(isAllYes && this.switched_checked_accept);
    },
    compinedHTML(elem,item) {
      return elem + " " + (item+1);
    },
    scrollIntoview(elem) {
      const e = document.querySelector(elem);
      e.scrollIntoView({ behavior: 'smooth', block: "end"});
    },
    selectProduct(productCode) {
      document.querySelectorAll('.buttonPrice').forEach((e)=> {
        e.value='Select';
      })
      document.getElementById(productCode.id).value="Selected";
      const product = productCode.getAttribute('data-product');
      const name = productCode.getAttribute('data-productname');
      const price = productCode.getAttribute('data-productprice');
      const category = productCode.getAttribute('data-productcategory');
      // clear addons
      if (this.check_product && this.check_product !== product) {
        this.initialRequest['addons'] = [];
        this.initialRequest['price_product_addon_sompo'] = 0;
      }
      // update initialRequest
      this.initialRequest['product'] = product;
      this.check_product = this.initialRequest['product'];
      // Update the links immediately after product is selected
      const doc = this.product_documents[product] || {};
      this.pwoLinkValue = doc.pwo_link || '#'; 
      this.ipidLinkValue = doc.ipid_link || '#';
      this.tobLinkValue = doc.tob_link || '#';
      this.pwoLinkValueAddition = doc.pwo_link_addition || null;
      // update product details
      this.initialRequest['product_name'] = name;
      this.initialRequest['price'] = price;
      this.initialRequest['product_category'] = category;
      this.initialRequest['env'] = 'production';
      this.productIsSelected=true;
      this.getProviderFlags(product);
    },
    getProviderFlags(product) {
      const isProvider = (num) =>
      product.startsWith(`product-single-${num}`) ||
      product.startsWith(`product-longstay-${num}`) ||
      product.startsWith(`product-annual-${num}`);

      this.product_is_mondial = isProvider('6');
      this.product_is_kemter = isProvider('8');
      this.product_is_battleface = isProvider('4');
      this.product_is_sompo = isProvider('3');
      this.additional_info_visible = false;
    },
    classicViewLayout() {
      const panel = document.querySelector("#products_panel_list");
      this.showProductsClassic = true;
      this.showProductsList = false;
      if (panel) {
        panel.ontransitionrun = () => {
          this.showSelectedTypeProducts(null,'Longstay','Annual');
          this.selectedProducts();
        };
      }
    },
    ListViewLayout() {
      const panel = document.querySelector("#products_panel");
      this.showProductsClassic = false;
      this.showProductsList = true;
      if (panel) {
        panel.ontransitionrun = () => {
          this.showSelectedTypeProducts(null,'Longstay','Annual');
          this.selectedProducts();
        };
      }
    },
    selectedProducts() {
      if (localStorage.getItem('checkedProducts') !== null && localStorage.getItem('checkedProducts') !== "") {
        const x = JSON.parse(localStorage.getItem('checkedProducts'));
        for (const [key, value] of Object.entries(x)) {
          document.querySelector("#offerpr_"+key).checked=true
          document.querySelector("#offercp_"+key).checked=true
        }
      }
    },
    annualDate() {
      let annual_date = new Date(this.range.start);
      annual_date.setDate(annual_date.getDate() + 364);
      const annual_date_locale = annual_date.toLocaleDateString('en-GB',{year: 'numeric', month: '2-digit', day: '2-digit'});
      this.initialRequest['annual_date'] = annual_date_locale;
    },
    daterangePickerToday() {
      //today dates to dd/mm//year format
      const start_date = this.range.start.toLocaleDateString('en-GB',{year: 'numeric', month: '2-digit', day: '2-digit'});
      const end_date = this.range.end.toLocaleDateString('en-GB',{year: 'numeric', month: '2-digit', day: '2-digit'});
      this.totalDays='1 day';
      //today dates on initialRequest in case of no select
      this.initialRequest['start_date'] = start_date;
      this.initialRequest['end_date'] = end_date;
      this.initialRequest['days'] = 1;
      // annual end date
      this.annualDate();
    },
    daterangePicker(e) {
      if (!e || !e.start || !e.end) {
        return;
      }
      //selected dates to dd/mm//year format
      const start_date = e.start.toLocaleDateString('en-GB',{year: 'numeric', month: '2-digit', day: '2-digit'});
      const end_date = e.end.toLocaleDateString('en-GB',{year: 'numeric', month: '2-digit', day: '2-digit'});
      // To calculate the time difference of two dates
      const Difference_In_Time = Math.abs(e.end.getTime() - e.start.getTime());
      const Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24))+1;
      //update initialRequest
      this.initialRequest['start_date'] = start_date;
      this.initialRequest['end_date'] = end_date;
      this.initialRequest['days'] = Difference_In_Days;
      // update reactive data instead of DOM
      this.date_range_label = Difference_In_Days > 1
        ? `${this.date_range} - ${Difference_In_Days} ${this.more_days}`
        : `${this.date_range} - 1 ${this.one_day}`;
      // annual end date
      this.annualDate();
      // empty get quote 
      this.clearQuote();
    },
    showClauses(elem) {
      const textarea = document.querySelector("#showclaussess");
      const textarea_val = [];
      elem.forEach((e,i)=> {
        if (e.id == 'Covid-19') {
          textarea_val.push(e.value + '\n\n');
        } 
        if (e.id == 'Business_Travel_Clause') {
          textarea_val.push(e.value + '\n\n');
        } 
        if (e.id == 'People_Already_Travelling') {
          textarea_val.push(e.value + '\n\n');
        } 
        if (e.id == 'Excess_Waiver_Extension_Endorsement') {
          textarea_val.push(e.value + '\n\n');
        } 
      })
      textarea.value=textarea_val.join('');
    },
    checkAdult(age) {
      return age >= 18;
    },
    isNumber(event) {
      const char = event.key;
      const isDigit = /\d/.test(char);
      const isComma = char === ',';
      const isControl = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(char);
      if (!isDigit && !isComma && !isControl) {
        event.preventDefault();
      }
    },
    onAgesBlur() {
      const rawInput = this.input_ages.trim();

      if (/,{2,}|^,|,$/.test(rawInput)) {
        this.resetTravellers("No leading/trailing or duplicate commas allowed.");
        return;
      }

      const ages = rawInput.split(',').map(a => a.trim()).filter(a => a !== '').map(Number);

      // Ensure all are numbers
      if (ages.some(isNaN)) {
        this.resetTravellers("All entries must be numbers.");
        return;
      }

      // Enforce age range 0–99
      if (ages.some(age => age < 0 || age > 99)) {
        this.resetTravellers("Please enter an age between 0 and 99.");
        return;
      }

      // Ensure at least one adult (i.e., not all < 18)
      if (!ages.some(this.checkAdult) && this.ls_role != 'admin') {
        this.resetTravellers("At least one adult supervisor is required.");
        return;
      }

      const sameAsExcel = JSON.stringify(ages) === JSON.stringify(this.agesArr);
      if (sameAsExcel && this.travellerData.length) return; // unchanged, keep Excel data
      this.travellerData = []; // manual edit → drop Excel data
      this.excelUploaded = false;

      this.duplicatecommas = null;
      this.adult_supervisor = null;

      this.updateAges(ages);
      this.addTravellers(ages);
    },
    updateAges(ages, travellerDetails = null) {
      this.numberoftravellers = [];
      this.dateBirthLabel = [];
      this.agesArr = [...ages];
      this.dobHighlightFlags = Array(ages.length).fill(true);
      this.initialRequest.travellersNumber = ages.length;
      this.updateTravellersFlag = true;

      const today = new Date();
      const isFirstDay = today.getDate() === 1;

      for (let i = 0; i < ages.length; i++) {
        const year = today.getFullYear() - ages[i];
        const day = isFirstDay ? today.getDate() : today.getDate() - 1;
        const calc_date = `${today.getMonth() + 1}-${day}-${year}`;

        this.numberoftravellers.push({
          id: `${i}`,
          title: travellerDetails?.[i]?.title || this.loadFormDts[0][`traveller_title${i + 1}`] || 'Mr.',
          firstname: travellerDetails?.[i]?.firstname || this.loadFormDts[1][`firstName${i + 1}`] || '',
          lastname: travellerDetails?.[i]?.lastname || this.loadFormDts[2][`lastName${i + 1}`] || '',
          date: travellerDetails?.[i]?.date || calc_date,
          mobile: travellerDetails?.[i]?.mobile || this.loadFormDts[3][`mobile${i + 1}`] || ''
        });
        this.dateBirthLabel.push({
          value: calc_date,
          age: ages[i],
          en: '', gr: '', fr: '', de: '', es: '', it: '', pl: '', ro: ''
        });
      }

      document.querySelector("#travellers_number").value = ages.length;
    },
    addTravellers() {
      if (!this.updateTravellersFlag) return;

      this.travellers = [];

      if (this.agesArr.length > 250) {
        this.maxTravellersAlert();
        return;
      }

      const useExcel = Array.isArray(this.travellerData) && this.travellerData.length > 0;

      if (useExcel) {
        for (const traveller of this.travellerData) {
          this.travellers.push({
            title: traveller.title,
            firstname: traveller.firstname,
            lastname: traveller.lastname,
            dob: traveller.date,
            age: traveller.age,
            mobile: traveller.mobile || ''
          });
        }
      } else {
        for (const age of this.agesArr) {
          const year = new Date().getFullYear() - age;
          const dob = `01-01-${year}`;
          this.travellers.push({
            title: "Mr.",
            firstname: `first_test_${age}`,
            lastname: `last_test_${age}`,
            dob,
            age: Number(age)
          });
        }
      }

      this.initialRequest.travellers = [...this.travellers];
      this.initialRequest.ages = this.input_ages;
      this.clearQuote();
      this.updateTravellersFlag = false;
    },
    resetTravellers(message) {
      this.excelUploaded = false;
      this.excelFile = null;
      this.input_ages = '';
      this.travellers = [];
      this.travellerData = [];
      this.travellers_number = 0;
      document.querySelector("#travellers_number").value = 0;
      this.duplicatecommas = message;
      this.adult_supervisor = null;
      // Clear arrays and reset flags related to travellers
      this.numberoftravellers = [];
      this.agesArr = [];
      this.dateBirthLabel = [];
      this.dobHighlightFlags = [];
      // Reset the count in the initial request (important for API)
      if(this.initialRequest) {
        this.initialRequest.travellersNumber = 0;
        this.initialRequest.travellers = [];
      }
    },
    formSubmitted() {
      location.reload();
    },
    synchBehalfOf(e) {
      if(this.ls_role == 'admin') {
        this.get_agents(e.value);
      }
      this.selectedBehalfOfHidden = e.text
    },
    agentSelected(e) {
      // empty get quote 
      this.clearQuote();
    },
    select_country_from(e) {
      this.initialRequest['res_name']=e.text;
      this.initialRequest['residence']=Number(e.value);
      this.fromCountryfHidden = e.text;
      // enable via
      if (this.initialRequest['residence'] && this.initialRequest['destination']) {
        this.viastate = false;
      }
      // empty get quote 
      this.clearQuote();
      // Notice Sompo logic based on EU membership
      if (euCountries.includes(e.text)) {
        this.$refs.noticeSompo.classList.add('d-none');
      } else {
        this.$refs.noticeSompo.classList.remove('d-none');
      }
    },
    select_title_to(elem, num) {
      const hidden = document.querySelector(`#traveller_title_hidden${num+1}`);
      hidden.value = elem.value;
      this.loadFormDts[0][`traveller_title${num+1}`] = elem;
    },
    select_country_to(e) {
      this.initialRequest['des_name']=e.text;
      this.initialRequest['destination']=Number(e.value);
      this.toCountryfHidden = e.text
      // enable via
      if (this.initialRequest['residence'] && this.initialRequest['destination']) {
        this.viastate = false;
      }
      // empty get quote 
      this.clearQuote();
    },
    select_country_via(e) {
      const res = this.initialRequest['residence'];
      const dest = this.initialRequest['destination'];
      const viaCodes=[];
      const viaCountries=[];
      e.forEach((elem,i)=> {
        viaCodes.push(elem.value);
        viaCountries.push(elem.text);
      })
      if (res && dest) {
        const vv=viaCodes.join('-');
        this.initialRequest['via'] = vv ? `${res}-${vv}-${dest}` : [ res, dest ].join('-');
        this.initialRequest['via_countries']=viaCountries;
      } 
      // empty get quote 
      this.clearQuote();
    },
    validateDates() {
      return new Promise((resolve, reject) => {
        if (!this.range || !this.range.start || !this.range.end) {
          this.dateIsEmpty = true;
          this.dateIsToday = false;
          reject("Please select both start and end dates.");
          return;
        } else {
          this.dateIsEmpty = false;
        }

        const start = new Date(this.range.start);
        const end = new Date(this.range.end);
        const today = new Date();
        const isStartToday = start.toDateString() === today.toDateString();
        const isEndToday = end.toDateString() === today.toDateString();

        if (isStartToday && isEndToday) {
          this.dateIsToday = true;
          reject("Start and End dates cannot both be today.");
        } else {
          this.dateIsToday = false;
          resolve(true);
        }
      });
    },
    async validationForm() {
      if(this.ls_role == 'admin') {
        this.initialRequest['token'] = this.selectedAgent?.value ? this.selectedAgent?.value : this.token_id;
      } else {
        this.initialRequest['token'] = this.token_id;
      }

      try {
        await this.validateDates();
        const success = await this.$refs.accountRules.validate();
        if (!success) {
          throw new Error('Form validation failed');
        }
        return true;
      } catch (err) {
        // Optionally set error message for UI feedback
        this.errorMessage = err.message || err;
        throw err;
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    countDownChanged1(dismissCountDown1) {
      this.dismissCountDown1 = dismissCountDown1
    },
    countDownChanged2(dismissCountDown2) {
      this.dismissCountDown2 = dismissCountDown2
    },
    showAlert(msg) {
      this.dismissCountDown = this.dismissSecs
      this.alertMsg=msg
    },
    maxTravellersAlert() {
      this.dismissCountDown2 = this.dismissSecs2
    },
    noProducrsAlert() {
      this.dismissCountDown1 = this.dismissSecs1
      this.showSaveOfferButton=false
    },
    validationFormInfo() {
      this.inputFillAge();
      if (this.productIsSelected == true) {
        return true;
      } else {
        this.scrollIntoview("#getQuote");
        this.showAlert(this.productsMsg);
        return false;
      }
    },
    dynamicInputValidate() {
      //focus,blur event for vee-validate dynamic inputs
      document.querySelectorAll(".travellersValidate").forEach((e)=> {
        e.focus();
        e.blur();
      })
    },
    inputFillAge() {
      const monthsWith31Days = [1, 3, 5, 7, 8, 10, 12];
      const dt = new Date();
      const currentMonth = dt.getMonth() + 1; // month as 1-12
      const currentDate = dt.getDate();
      const currentYear = dt.getFullYear();

      // check before the loop
      if (!this.agesArr || !this.initialRequest || !this.initialRequest['travellersNumber']) {
        console.error('Missing ages array or travellers number');
        return;
      }

      for (let i = 0; i < this.initialRequest['travellersNumber']; i++) {
        const calculateYear = currentYear - this.agesArr[i];
        let todayDateStr;

        if (currentDate === 1) {
          // Special case: Jan 1st → Dec 31 previous year
          if (currentMonth === 1) {
            todayDateStr = `31-12-${calculateYear - 1}`;
          }
          // Months with 31 days (on 1st, previous day is 31st of previous month)
          else if (monthsWith31Days.includes(currentMonth)) {
            todayDateStr = `31-${('0' + (currentMonth - 1)).slice(-2)}-${calculateYear}`;
          }
          // February
          else if (currentMonth === 2) {
            // Feb has 28 or 29 days
            const febDays = this.leapYear(calculateYear) ? 29 : 28;
            todayDateStr = `${febDays}-02-${calculateYear}`;
          }
          // Months with 30 days
          else {
            todayDateStr = `30-${('0' + (currentMonth - 1)).slice(-2)}-${calculateYear}`;
          }
        } else {
          // Regular case: previous day same month
          todayDateStr = `${('0' + currentDate).slice(-2)}-${('0' + currentMonth).slice(-2)}-${calculateYear}`;
        }

        const prevDateMoment = moment(`${currentDate}-${currentMonth}-${calculateYear - 1}`, "DD-MM-YYYY").add(1, "days");
        const prevDateStr = prevDateMoment.format("DD-MM-YYYY");

        this.todayval[i] = todayDateStr;
        this.prevval[i] = prevDateStr;

        this.dateBirthLabel[i].value = this.date_of_birth + ' (' + this.agesArr[i] + ' ' + this.date_between + this.prevval[i] + ' - ' + this.todayval[i] + ')';
        this.dateBirthLabel[i].en = 'Date of Birth (' + this.agesArr[i] + ' years old, between: ' + this.prevval[i] + ' - ' + this.todayval[i] + ')';
        this.dateBirthLabel[i].fr = 'Date de naissance (' + this.agesArr[i] + ' ans, entre: ' + this.prevval[i] + ' - ' + this.todayval[i] + ')';
        this.dateBirthLabel[i].de = 'Geburtsdatum (' + this.agesArr[i] + ' Jahre alt, zwischen: ' + this.prevval[i] + ' - ' + this.todayval[i] + ')';
        this.dateBirthLabel[i].gr = 'Ημερομηνία γέννησης (' + this.agesArr[i] + ' χρονών, μεταξύ: ' + this.prevval[i] + ' - ' + this.todayval[i] + ')';
        this.dateBirthLabel[i].es = 'Fecha de nacimiento (' + this.agesArr[i] + ' años, entre: ' + this.prevval[i] + ' - ' + this.todayval[i] + ')';
        this.dateBirthLabel[i].pl = 'Data urodzenia (' + this.agesArr[i] + ' lat, między: ' + this.prevval[i] + ' - ' + this.todayval[i] + ')';
        this.dateBirthLabel[i].ro = 'Data nașterii (' + this.agesArr[i] + ' ani, cu vârsta cuprinsă între: ' + this.prevval[i] + ' - ' + this.todayval[i] + ')';
        this.dateBirthLabel[i].it = 'Data di nascita (' + this.agesArr[i] + ' anni, tra: ' + this.prevval[i] + ' - ' + this.todayval[i] + ')';
      }
    },
    moment: function () {
      return moment();
    },
    getAge(birthDate) {
      return moment().diff(moment(birthDate, "DD-MM-YYYY"), 'years');
    },
    calulateAge() {
      this.birthDatesArr=[];
      document.querySelectorAll(".form_control_dateofbirth").forEach((e,i)=> {
        const picker_year = e.value.slice(6);
        const picker_day = e.value.slice(0,2);
        const picker_month = e.value.slice(3,5);
        const formatted_date =  picker_day + "-" + picker_month + "-" + picker_year;
        this.birthDatesArr.push(this.getAge(formatted_date));
        // console.warn(this.getAge(formatted_date))
      })
    },
    checkAge(a,b) {
      // check which datepicker index doesnt match
      a.forEach(function(item,i) {
        if (item !== b[i]) {
          document.getElementById("dateofbirth"+(i+1)).style.border = "1px solid #ea5455";
        } else {
          document.getElementById("dateofbirth"+(i+1)).style.border = "1px solid #ced4da";
        }
      })
      // return equal arrays
			return JSON.stringify(a) === JSON.stringify(b);
    },
    validationFormAddress() {
      this.dynamicInputValidate();
      this.calulateAge();
      if (!this.checkAge(this.birthDatesArr, this.agesArr)) {
        // console.warn(this.birthDatesArr);
        // console.warn(this.agesArr);
        return false;
      }
      // delete addons if they are empty
      if (!this.initialRequest.addons || this.initialRequest.addons.length === 0) {
        delete this.initialRequest.addons;
        delete this.initialRequest.price_product_addon_sompo;
      }
      // start additional info, contact details to initialRequest
      this.initialRequest['additional_info']={
        'contracted_party_type' : this.contractedPartyTypeSelected.value ?? '',
        'company_name' : this.company_name,
        'document_type' : this.documentTypeSelected.value ?? '',
        'document_number' : this.document_number,
        'document_authority' : this.documentAuthoritySelected.value ?? '',
        'document_authority_certification' : this.document_authority_certification,
        'trip_information_text' : this.trip_info_text,
        'arrival_city' : this.arrival_city,
        'travel_price' : this.travel_price,
        'postcode' : this.customer_zip_code,
        'phone' : this.customer_telephone,
        'mobile' : this.customer_telephone,
        'country' : this.selectedContryPolicyHolder?.text ?? '',
        'street' : this.customer_street,
        'number' : this.street_number,
        'area' : this.customer_area,
        'city' : this.customer_city,
      }
      this.initialRequest['email'] = this.contact_email;
      this.initialRequest["address"] = this.customer_city + ", " + this.customer_area + ", " + this.customer_street + " " + this.street_number;
      this.initialRequest['street'] = this.customer_street;
      this.initialRequest['number'] = this.street_number;
      this.initialRequest['area'] = this.customer_area;
      this.initialRequest['city'] = this.customer_city;
      this.initialRequest['country'] = this.selectedContryPolicyHolder?.text ?? '';

      this.initialRequest["telephone"] 	                        = this.customer_telephone;
      this.initialRequest["tax_identification_number"] 	        = this.tax_identification_number;
      this.initialRequest["agencyid"]        = "" ;
      this.initialRequest["postcode"] = this.customer_zip_code;
      this.initialRequest["school"] = this.customer_school ?? '';

      for (let i = 1; i <= this.initialRequest["travellers"].length; i++){
        const m = document.querySelector(`#mobile${i}`).value;
				this.initialRequest["travellers"][i-1]["title"] = document.querySelector(`#traveller_title_hidden${i}`).value;
				this.initialRequest["travellers"][i-1]["firstname"] = document.querySelector(`#firstName${i}`).value;
				this.initialRequest["travellers"][i-1]["lastname"] = document.querySelector(`#lastName${i}`).value;
				this.initialRequest["travellers"][i-1]["dob"] = document.querySelector(`#dateofbirth${i}`).value.split('-').join('/');
        if (m) {
          this.initialRequest["travellers"][i-1]["phone"] = m;
        } else {
          this.initialRequest["travellers"][i-1]["phone"] = this.customer_telephone;
        }
			}
      // end additional info, contact details to initialRequest
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormSocial() {
      sessionStorage.setItem("initialRequest_"+Date.now(), JSON.stringify(this.initialRequest));
      // console.warn(this.initialRequest);
      return new Promise((resolve, reject) => {
        this.$refs.socialRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    waitForElm(selector) {
      return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
      });
    },
    async getQuote(e) {
      if (this.agesArr.length > 250) {
        this.maxTravellersAlert();
        return false;
      }
      // delete addons to avoid confusion on backend and in request
      delete this.initialRequest.addons;
      delete this.initialRequest.price_product_addon_sompo;

      this.isGettingQuote = true;
      const products_panel = document.getElementById("products_panel");
      const products_panel_list = document.getElementById("products_panel_list");
      this.initialRequest['product']=[];
      this.initialRequest['env']='production';
      const url = {remote:{all:'https://api-quote.safetravel.today/v2/app/quote'}, available:'https://api-quote.safetravel.today/v2/products/available'};
      // empty div with products
      if (products_panel) {
        products_panel.innerHTML = "";
      }
      if (products_panel_list) {
        products_panel_list.innerHTML = "";
      }
      // empty products array
      this.ajax_products=[];
      this.all_products_arr=[];
      // unselect product flag
      this.productIsSelected=false;

      if (this.ls_scope.includes('app.travel-insurance.quote')) {
        try {
          await fetch(url.remote.all, {
            method: 'post',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify(this.initialRequest)
          })
          .then(response => {
            if (!response.ok) throw new Error(`Failed to get quote: HTTP ${response.status}`);
            return response.json();
          })
          .then((data)=> {
            // console.warn(data)
            if (Array.isArray(data)) {
              this.all_products_arr = [...data];
            } else {
              console.error('Unexpected data format:', data);
              this.all_products_arr = [];
            }
          })
          .then((res)=> {
            // console.warn(res)
            this.ajax_products=this.all_products_arr;
            //show products
            this.showProducts=true;
            // Enable Save Offer button again
            this.showSaveOfferButton = true;
          })
          .then(()=> {
            // Match selected category to filtering logic
            let removeOne, removeTwo;
            if (this.selectedProductCategory === "SingleTrip") {
              removeOne = "Longstay"; removeTwo = "Annual";
            } else if (this.selectedProductCategory === "Longstay") {
              removeOne = "SingleTrip"; removeTwo = "Annual";
            } else {
              removeOne = "SingleTrip"; removeTwo = "Longstay";
            }
            this.activeButton = this.selectedProductCategory;
            this.showSelectedTypeProducts(null, removeOne, removeTwo);
            })
        } catch (error) {
          console.error(error);
          this.showAlert(this.getQuoteMsg)
        } finally {
          this.isGettingQuote = false;
        }
      } else {
        this.paymentmodalerrorshow=true
        this.errorbuyProductModalMsg="You are not permitted to perform this action."
      }
    },
    saveFN(event, id) {
        this.loadFormDts[1][`firstName${id+1}`] = event;
    },
    saveLN(event, id) {
        this.loadFormDts[2][`lastName${id+1}`] = event;
    },
    saveMB(event, id) {
        this.loadFormDts[3][`mobile${id+1}`] = event;
    },
    clearQuote() {
      this.showProducts=false;
      this.productIsSelected=false;
    },
    async loadActiveCompanies() {
      this.agentName=[];
      const url= {
        prod: 'https://api-quote.safetravel.today/v2/app/get_company_names'
      };
      const data = {
        token: this.token_id,
        jwt: this.cookie
      }
      try {
        await fetch(url.prod, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
        .then((response) => {
          if (!response.ok) throw new Error(`Failed to get company names: HTTP ${response.status}`);
          return response.json();
        })
        .then((res)=> {
          if (res) {
            if (res === 'not_valid') {
              performLogoutWithoutRedirect(this.$store)
              return;
            }
            res.forEach(r=> {
              this.behalfOf.push({
                text: r?.company_name ?? null,
                value: r?.organization_id ?? null,
              })
            })
          }
        })
      } catch (error) {
        // TypeError: Failed to fetch
        console.warn('There was an error fetching on behalf_of', error);
      }
    },
    async get_agents(value) {
      this.agentName=[];
      const url= {
        prod: 'https://api-quote.safetravel.today/v2/app/get_agents'
      };
      const data = {
        token: this.token_id,
        jwt: this.cookie,
        organization_id: Number(value)
      }
      try {
        await fetch(url.prod, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
        .then((response) => {
          if (!response.ok) throw new Error(`Failed to get agents: HTTP ${response.status}`);
          return response.json();
        })
        .then((res)=> {
          if (res) {
            if (res === 'not_valid') {
              performLogoutWithoutRedirect(this.$store)
              return;
            }
            // set selectedAgent the first result
            this.selectedAgent.text = res[0]?.email ?? '-'
            this.selectedAgent.value = res[0]?.token ?? this.token_id
            res.forEach(r=> {
              this.agentName.push({
                text: r?.email ?? null,
                value: r?.token ?? null,
              })
            })
          }
        })
      } catch (error) {
        // TypeError: Failed to fetch
        console.warn('There was an error fetching agents', error);
      }
    }
  },
  created() {
    if(this.ls_role == 'admin') {
      this.loadActiveCompanies()
    }
  },
  mounted() {
    if (localStorage.getItem("checkedProducts") !== null) {
      localStorage.removeItem("checkedProducts");
    }
    this.populateFormDts();
    this.daterangePickerToday();
    this.checkPreviousQuotations();
    this.savedQuotation();
    this.savedQuotationApp();
    // this.removeQuoteInfoReload();
    this.evaluateBuyPolicyStatus();
  },
  watch: {
    selected_coverages: 'evaluateBuyPolicyStatus',
    selected_treatment: 'evaluateBuyPolicyStatus',
    selected_medical: 'evaluateBuyPolicyStatus',
    consent_pd: 'evaluateBuyPolicyStatus',
    confirm_plword: 'evaluateBuyPolicyStatus',
    confirm_prv_plcy: 'evaluateBuyPolicyStatus',
    switched_checked_accept: 'evaluateBuyPolicyStatus',
    sliderStatus(newVal) {
      if (newVal) {
        this.initSliderDrag();
      } else {
        this.removeSliderDrag();
      }
    },
    '$i18n.locale': function(newVal, oldVal) {
      this.dateBirth_i = newVal;
    },
    ajax_products: {
       handler(val) {
        // console.warn(val)
        this.product_price=[];
        this.product_currency=[];
        this.product_currency_symbol=[];
        this.product_category=[];
        this.product_code=[];
        this.product_description=[];
        this.product_name=[];
        this.product_short_description=[];
        this.primary=[];
        this.secondary=[];
        
        for (let i = 0; i < val.length; i++) {
          this.product_price.push(val[i].gross_price ?? '');
          this.product_currency.push(val[i].currency ?? '');
          this.product_currency_symbol.push(val[i].currency_symbol ?? '');
          this.product_category.push((val[i].product?.product_info?.product_category)?.replace(/ +/g, "") ?? '');
          this.product_code.push(val[i].product?.product_info?.product_code ?? '');
          this.product_description.push(val[i].product?.product_info?.product_description || 'desc. available soon.');
          this.product_name.push(val[i].product?.product_info?.product_name ?? 'Unavailable');
          const productDescription = val[i].product?.product_info?.product_description;
          let shortDescription = 'desc. available soon.';
          if (typeof productDescription === 'string' && productDescription) {
            const sentences = productDescription.split('.');
            shortDescription = sentences.slice(0, 2).join('.') + (sentences.length > 1 ? '.' : '');
          }
          this.product_short_description.push(shortDescription);  
          this.primary.push(val[i].coverages?.primary);
          this.secondary.push(val[i].coverages?.secondary);   
        }
        this.resCheckName = this.initialRequest['res_name'];
        this.destCheckName = this.initialRequest['des_name'];
      },
      deep: true,
    }
  }
}
</script>
<style scoped>
  .singletripbtn, .singletripbtn_f {
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
  }
  .annualtripbtn, .annualtripbtn_f {
    border-top-right-radius: 14px;
    border-bottom-right-radius: 14px;
    display:flex;
    align-items:center;
  }
  .mb-cst {
    margin-bottom: 3px;
  }
  .mt-cst {
    margin-bottom: 10px;
  }
  .ml-cst {
    margin-left: 5px;
  }
  .nowrapview {
    flex-wrap: nowrap;
    overflow-x: scroll;
  }
  #products_panel_list {
    flex-wrap: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
    width: 100%;
  }
  #products_panel_list::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: var(--bg-color);
  }
  #products_panel_list::-webkit-scrollbar {
    width: 11px;
    height: 11px;
    background-color: var(--bg-color);
  }
  #products_panel_list::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: var(--foreground-color);
  }
  /* start bs alert */
  .alert-danger {
    background-color: var(--info);
    border-color: var(--info);
  }
  .alert-dismissible {
    padding-right: 4rem;
  }
  .alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
  }
  .alert-dismissible .close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 0.75rem 1.25rem;
    color: inherit;
    cursor: pointer;
  }
  button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
  }
  .close {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: var(--black);
    text-shadow: 0 1px 0 var(--bg-color);
    opacity: .5;
  }
  /* end bs alert */
  .tripPlanning {
    color: var(--foreground-color);
    font-weight: 600;
  }
  .highlight-dob {
    outline: 1px solid yellow;
  }
  .transition-icon {
    transition: transform 0.25s ease;
  }
  .rotate-up {
    transform: rotate(180deg);
  }
  .rotate-down {
    transform: rotate(0deg);
  }
    /* Slider styles */
    .slider-buttons-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    pointer-events: none; /* so clicks pass through unless on button */
  }
  .scroll-button {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 48px; /* Or more if needed */
    background: rgba(40, 167, 69, 0.05); /* light green overlay */
    border: none;
    cursor: pointer;
    pointer-events: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s;
    z-index: 5;
  }
  .scroll-button.left {
    left: 0;
  }
  .scroll-button.right {
    right: 0;
  }
  .scroll-button:hover {
    background-color: rgba(86, 148, 149, 0.35);
  }
  .arrow-icon {
    color: var(--foreground-color);
    pointer-events: none; /* makes sure click is on the button, not the icon */
    font-weight: 700;
  }
  /* End Slider styles */
  /* excel pointer */
  .excel-file ::v-deep .custom-file-input,
  .excel-file ::v-deep .custom-file-label,
  .excel-file ::v-deep .custom-file-label::after {
    cursor: pointer !important;
  }
</style>